import React, { useState, useEffect, memo ,useRef,useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, Link as RouterLink, useNavigate, BrowserRouter as Router, Switch, Route, NavLink } from 'react-router-dom';
import { toast } from "react-toastify";
import TableToExcel from '@linways/table-to-excel';
import imageCompression from 'browser-image-compression';
import exifr from 'exifr';
// @mui  
// import * as XLSX from 'xlsx';
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import pLimit from 'p-limit'; 
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import config from '../../config';
import { encryptData } from '../../utils/cryptoUtils';
import * as leadActions from "../../actions/leadActions";


const LeadQuestionnaire = ({ questions, checklistInfo, props, setOpen, fetchLeads, updateParentState, userRoleType, leadStatusFlag,camLatestStatus,setSectionName }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const { leadInfo, leadData, actions } = props;
    const [currentChecklistId, setCurrentChecklistId] = useState(checklistInfo.id);
    const [leadId, setLeadId] = useState(checklistInfo.lead_id);
    const [questionnaireData, setQuestionnaireData] = useState(questions);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [answers, setAnswers] = useState(Array(questionnaireData.length).fill(''));
    const [fieldInvestigationFalg, setFieldInvestigationFalg] = useState(false);
    const [showButtonOrNot, setShowButtonOrNot] = useState(false);

     const [whetheCustomerStatus, setWhetheCustomerStatus] = useState(false);
     const [otherTextData, setOtherTextData] = useState('');

     const [currentAddressAsPerCAMVisited, setCurrentAddressAsPerCAMVisited] = useState(false);
     const [currentAddressAsPerCAMVisitedTextData, setCurrentAddressAsPerCAMVisitedTextData] = useState('');

     const [accountStatus, setAccountStatus] = useState(false);
     const [neighbourFeedbackInCaseSkiporODCaseVal, setNeighbourFeedbackInCaseSkiporODCaseVal] = useState('');

     const [vehicleUsedBy, setVehicleUsedBy] = useState('');
     const [thirdPartyNameVal, setThirdPartyNameVal] = useState('');
     const [thirdPartyAddressVal, setThirdPartyAddressVal] = useState('');
     const [thirdPartyPhoneNumberVal, setThirdPartyPhoneNumberVal] = useState('');

     const [vehicleReadinginKMVal, setVehicleReadinginKMVal] = useState('');
     const [monthlyEarningViabilityVal, setMonthlyEarningViabilityVal] = useState('');
     const [anyPerformanceIssueWithTheVehicleVal, setAnyPerformanceIssueWithTheVehicleVal] = useState('');

    const [currentAddressOfGuarantor, setCurrentAddressOfGuarantor] = useState(false);
    const [guarantorVisitedAddressVal, setGuarantorVisitedAddressVal] = useState('');
    const [doYouWantToReferSomeoneForLoan, setDoYouWantToReferSomeoneForLoan] = useState(false);
    const [personNameWhomYouWantToReferVal, setPersonNameWhomYouWantToReferVal] = useState('');
    const [personContactDetailsWhoYouWantToReferVal, setPersonContactDetailsWhoYouWantToReferVal] = useState('');

    const [overallFeedbackAbouttheVisitforCustomerVal, setOverallFeedbackAbouttheVisitforCustomerVal] = useState('');
    const [overallFeedbackAbouttheVisitforGuarantorCoapplicantVal, setOverallFeedbackAbouttheVisitforGuarantorCoapplicantVal] = useState('');
     
     
     
    const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
    const [allUploadLeadDocument, setAllUploadLeadDocument] = useState([]);
    const formRef = useRef(null);
    const [propLeadId, setPropLeadId] = useState('');
    const [allDocumentTypeData, setAllDocumentTypeData] = useState([]);
     const [viewModalInfo, setViewModalInfo] = useState([]);
    const [isMobile, setIsMobile] = useState(null); 
    const fileInputRef = useRef();
    const cameraInputRef = useRef();
    const [previews, setPreviews] = useState([]);
    const [compressedFiles, setCompressedFiles] = useState([]);
    const [imageDetails, setImageDetails] = useState([]);
    const [preloaderStatus, setPreloaderStatus] = useState(false);
    const [preloaderSubmitStatus, setPreloaderSubmitStatus] = useState(false);
    const [uploadProgressMap, setUploadProgressMap] = useState({});  // Tracks { filename: % }
    const [folderId, setFolderId] = useState(false);

    const [allchecklistUploadIds, setAllchecklistUploadIds] = useState('');
    const [lastFormSubmitStatus, setLastFormSubmitStatus] = useState(false);

    const [actionHandlerStatus, setActionHandlerStatus] = useState('');

    const intervalRef = useRef(null);
    const [decodedAddresses, setDecodedAddresses] = useState({});
    const [expandedAddresses, setExpandedAddresses] = useState({});
    const [decodingIds, setDecodingIds] = useState({});

    const [overlayState, setOverlayState] = useState({
        visible: false,
        total: 0,
        completed: 0,
        failedCount: 0,
        progressPercent: 0, // per-file progress
        message: '',
        retryFiles: []
      });

      function isMobileDevice() {
        return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    useEffect(() => {
        console.log("questions, ", questions);
        console.log("leadInfo = , ", leadInfo);
        console.log("checklistInfo = , ", checklistInfo);
        const userAnswersArray = questions.map((item) => (item.userAnswers ? item.userAnswers[0] : ''));
        setAnswers(userAnswersArray);
        const isMobileStatus = isMobileDevice();
        setIsMobile(isMobileStatus);

          // Set value for Vehicle Reading in KM if question exists
            questionnaireData.forEach((currentQuestion, questionIndex) => {
                if ( currentQuestion?.questionText?.trim() === "Vehicle Reading in KM" ) {
                    setVehicleReadinginKMVal(userAnswersArray[questionIndex]);
                }

                  if(currentQuestion?.questionText?.trim() === 'Whether customer address is where vehicle inspection is being done or not?'){
                        if(userAnswersArray[questionIndex] === 'Yes' || userAnswersArray[questionIndex] === 'No'){
                           setWhetheCustomerStatus(userAnswersArray[questionIndex] === 'No');
                         }
                    } 

                    if(currentQuestion?.questionText?.trim() === 'Current Address as per CAM visited?'){
                        
                        if(userAnswersArray[questionIndex] === 'Yes' || userAnswersArray[questionIndex] === 'No'){
                            setCurrentAddressAsPerCAMVisited(userAnswersArray[questionIndex] === 'No');
                        }
                    } 

                    if(currentQuestion?.questionText?.trim() === 'Account Status'){              
                        if(userAnswersArray[questionIndex] === 'Regular' || userAnswersArray[questionIndex] === 'OD'  || userAnswersArray[questionIndex] === 'NPA'  || userAnswersArray[questionIndex] === 'Skip' || userAnswersArray[questionIndex] === 'EDA'){
                        setAccountStatus(userAnswersArray[questionIndex] === 'OD' || userAnswersArray[questionIndex] === 'Skip'); 
                        }
                    } 
                    
                    if(currentQuestion?.questionText?.trim() === 'Neighbour feedback In case Skip or OD Case'){
                        setNeighbourFeedbackInCaseSkiporODCaseVal(userAnswersArray[questionIndex]);
                    } 

                    if(currentQuestion?.questionText?.trim() === 'Vehicle is being used by Customer or 3rd Party'){        
                        setVehicleUsedBy(userAnswersArray[questionIndex]); 
                    } 

                    if(currentQuestion?.questionText?.trim() === 'Third party Name'){
                        setThirdPartyNameVal(userAnswersArray[questionIndex]);
                    }
                    if(currentQuestion?.questionText?.trim() === 'Third Party Address'){
                        setThirdPartyAddressVal(userAnswersArray[questionIndex]);
                    } 
                    if(currentQuestion?.questionText?.trim() === 'Third party Phone number'){
                        setThirdPartyPhoneNumberVal(userAnswersArray[questionIndex]);
                    } 
                    
                    if(currentQuestion?.questionText?.trim() === 'Vehicle Reading in KM'){
                        setVehicleReadinginKMVal(userAnswersArray[questionIndex]);
                    } 
                    if(currentQuestion?.questionText?.trim() === 'Monthly earning/ Viability'){
                        setMonthlyEarningViabilityVal(userAnswersArray[questionIndex]);
                    } 
                    if(currentQuestion?.questionText?.trim() === 'Any Performance issue with the Vehicle'){
                        setAnyPerformanceIssueWithTheVehicleVal(userAnswersArray[questionIndex]);
                    } 

                    if(currentQuestion?.questionText?.trim() === 'Current Address of Guarantor as per CAM visited? Is it same ? If No Please mention the address'){              
                        if(userAnswersArray[questionIndex] === 'Yes' || userAnswersArray[questionIndex] === 'No'){
                        setCurrentAddressOfGuarantor(userAnswersArray[questionIndex] === 'No');
                        }
                    }

                    if(currentQuestion?.questionText?.trim() === "Guarantor's Visited Address"){
                        setGuarantorVisitedAddressVal(userAnswersArray[questionIndex]);
                    }
                    
                    if(currentQuestion?.questionText?.trim() === 'Do you want to refer someone for a loan?'){
                        if(userAnswersArray[questionIndex] === 'Yes' || userAnswersArray[questionIndex] === 'No'){
                        setDoYouWantToReferSomeoneForLoan(userAnswersArray[questionIndex] === 'Yes');
                        }
                    } 

                    if(currentQuestion?.questionText?.trim() === 'Person name whom you want to refer?'){
                        setPersonNameWhomYouWantToReferVal(userAnswersArray[questionIndex]);
                    } 

                    if(currentQuestion?.questionText?.trim() === 'Person contact details who you want to refer?'){
                        setPersonContactDetailsWhoYouWantToReferVal(userAnswersArray[questionIndex]);
                    } 


                    if(currentQuestion?.questionText?.trim() === "Overall Feedback About the Visit for Customer"){
                        setOverallFeedbackAbouttheVisitforCustomerVal(userAnswersArray[questionIndex]); 
                    }

                    if(currentQuestion?.questionText?.trim() === "Overall Feedback About the Visit for Guarantor/Co applicant"){
                        setOverallFeedbackAbouttheVisitforGuarantorCoapplicantVal(userAnswersArray[questionIndex]); 
                    }   
                
            });

    }, [actions, leadInfo,questionnaireData]);

    useEffect(() => {
        if (checklistInfo && checklistInfo.check_list_name === "Field Investigation") {
            setFieldInvestigationFalg(true);
        } else {
            setFieldInvestigationFalg(false);
        }

        if (checklistInfo && checklistInfo.fieldInvestigationFalg === "1") {
            setShowButtonOrNot(true);
        } else {
            setShowButtonOrNot(false);
        }

     

    }, [checklistInfo, setFieldInvestigationFalg, setShowButtonOrNot]);

    console.log("showButtonOrNot : ", showButtonOrNot);

    const [checklistData, setChecklistData] = useState([]);
    useEffect(() => {
        if (props.checklistInfo) {
            setCurrentChecklistId(props.checklistInfo.id);

            if( props.checklistInfo.lead_id !== '' && props.checklistInfo.lead_id !== undefined){
                 setLeadId(props.checklistInfo.lead_id);
            }           
        }
        handleChecklistID();
    }, [props.checklistInfo]);

    useEffect(() => {
        handleChecklistID();
    }, []);

    const handleDeleteRow = (id) => {
        const requestData = encryptData({ id });
        const response = actions.checklistDeleteData(requestData, false);

        response.then((result) => {
            if (result.data.status === 200) {
                console.log("Deletion Result:", result.data);
                toast.success('Item deleted successfully', {
                    position: 'top-right',
                });
                handleChecklistID();
            }
        })
            .catch((error) => {
                console.error("Error deleting item:", error);
                toast.error('Failed to delete item. Please try again later.', {
                    position: 'top-right',
                });
            });
    };
    // alert(config.GOOGLE_MAPS_API_KEY);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    const fetchFromNominatim = async (latitude, longitude) => {
    const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&addressdetails=1&zoom=18`,
        { headers: { Accept: 'application/json' } }
    );
    if (!response.ok) {
        throw new Error(`Nominatim HTTP ${response.status}`);
    }
    const data = await response.json();

    if (!data) {
        throw new Error('Nominatim returned no data');
    }

    // display_name is the complete, authoritative address string Nominatim builds.
    // The `address` breakdown object can OMIT levels (POI names under `highway`,
    // tehsil/county names, etc.) that ARE present in display_name — so rebuilding
    // the address manually from `address` fields will silently drop pieces.
    // Use display_name first; only fall back to manual reconstruction if it's missing.
    if (data.display_name) {
        return data.display_name;
    }

    const addr = data.address || {};
    const parts = [];

    if (addr.house_number) parts.push(addr.house_number);
    if (addr.building) parts.push(addr.building);
    if (addr.highway && !parts.includes(addr.highway)) parts.push(addr.highway); // was missing
    if (addr.road && !parts.includes(addr.road)) parts.push(addr.road);
    if (addr.neighbourhood && !parts.includes(addr.neighbourhood)) parts.push(addr.neighbourhood);
    if (addr.suburb && !parts.includes(addr.suburb)) parts.push(addr.suburb);
    if (addr.city_district && !parts.includes(addr.city_district)) parts.push(addr.city_district);
    if (addr.village && !parts.includes(addr.village)) parts.push(addr.village);
    if (addr.town && !parts.includes(addr.town)) parts.push(addr.town);
    if (addr.city && !parts.includes(addr.city)) parts.push(addr.city);
    if (addr.county && !parts.includes(addr.county)) parts.push(addr.county);
    if (addr.state_district && !parts.includes(addr.state_district)) parts.push(addr.state_district);
    if (addr.state && !parts.includes(addr.state)) parts.push(addr.state);
    if (addr.postcode) parts.push(addr.postcode);
    if (addr.country && !parts.includes(addr.country)) parts.push(addr.country);

    const uniqueParts = [...new Set(parts.filter(Boolean))];

    if (uniqueParts.length > 0) {
        return uniqueParts.join(', ');
    }

    throw new Error(data?.error || 'Nominatim returned no address');
};

    const fetchFromBigDataCloud = async (latitude, longitude) => {
        const response = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
        );
        if (!response.ok) {
            throw new Error(`BigDataCloud HTTP ${response.status}`);
        }
        const data = await response.json();

        const parts = [];

        if (data.locality) parts.push(data.locality);
        if (data.city && data.city !== data.locality) parts.push(data.city);

        const adminList = data.localityInfo?.administrative || [];
        const usefulAdminLevels = adminList.filter(
            (a) => a.adminLevel === 5 || a.adminLevel === 6
        );
        usefulAdminLevels.forEach((a) => {
            if (a.name && !parts.includes(a.name)) {
                parts.push(a.name);
            }
        });

        if (data.principalSubdivision && !parts.includes(data.principalSubdivision)) {
            parts.push(data.principalSubdivision);
        }
        if (data.postcode) parts.push(data.postcode);
        if (data.countryName) parts.push(data.countryName);

        if (parts.length > 0) {
            return parts.join(', ');
        }
        if (data.localityInfo?.informative?.length > 0) {
            return data.localityInfo.informative.map((i) => i.name).join(', ');
        }
        throw new Error('BigDataCloud returned no address');
    };
   const handleDecodeAddress = async (item) => {
    if (!item.latitude || !item.longitude) return;

    setDecodingIds(prev => ({ ...prev, [item.id]: true }));

    let resolvedAddress = null;
    let source = null; // 'Nominatim' | 'BigDataCloud' | null

    // Attempt 1: Nominatim
    try {
        resolvedAddress = await fetchFromNominatim(item.latitude, item.longitude);
        if (resolvedAddress) source = 'Nominatim (nominatim.openstreetmap.org)';
    } catch (err) {
        console.warn('Nominatim attempt 1 failed:', err.message);
    }

    // Attempt 2: Retry Nominatim after short wait
    if (!resolvedAddress) {
        await delay(1200);
        try {
            resolvedAddress = await fetchFromNominatim(item.latitude, item.longitude);
            if (resolvedAddress) source = 'Nominatim (nominatim.openstreetmap.org) — retry';
        } catch (err) {
            console.warn('Nominatim attempt 2 failed:', err.message);
        }
    }

    // Attempt 3: Fallback to BigDataCloud
    if (!resolvedAddress) {
        try {
            resolvedAddress = await fetchFromBigDataCloud(item.latitude, item.longitude);
            if (resolvedAddress) source = 'BigDataCloud (api.bigdatacloud.net)';
        } catch (err) {
            console.warn('BigDataCloud fallback failed:', err.message);
        }
    }

    setDecodedAddresses(prev => ({
        ...prev,
        [item.id]: {
            address: resolvedAddress || 'Address not found',
            source: source || 'None',
        },
    }));

    setDecodingIds(prev => ({ ...prev, [item.id]: false }));
};  
    // const handleDecodeAddress = async (item) => {
    //     if (!item.latitude || !item.longitude) return;

    //     setDecodingIds(prev => ({ ...prev, [item.id]: true }));

    //     let resolvedAddress = null;

    //     // Attempt 1: Nominatim
    //     try {
    //         resolvedAddress = await fetchFromNominatim(item.latitude, item.longitude);
    //     } catch (err) {
    //         console.warn('Nominatim attempt 1 failed:', err.message);
    //     }

    //     // Attempt 2: Retry Nominatim after short wait
    //     if (!resolvedAddress) {
    //         await delay(1200);
    //         try {
    //             resolvedAddress = await fetchFromNominatim(item.latitude, item.longitude);
    //         } catch (err) {
    //             console.warn('Nominatim attempt 2 failed:', err.message);
    //         }
    //     }

    //     // Attempt 3: Fallback to BigDataCloud
    //     if (!resolvedAddress) {
    //         try {
    //             resolvedAddress = await fetchFromBigDataCloud(item.latitude, item.longitude);
    //         } catch (err) {
    //             console.warn('BigDataCloud fallback failed:', err.message);
    //         }
    //     }

    //     setDecodedAddresses(prev => ({
    //         ...prev,
    //         [item.id]: resolvedAddress || 'Address not found',
    //     }));

    //     setDecodingIds(prev => ({ ...prev, [item.id]: false }));
    // };

  
    
    useEffect(() => {
            const itemsToDecode = checklistData.filter(
                (item) => item.latitude && item.longitude && !decodedAddresses[item.id] && !decodingIds[item.id]
            );

            const cancelledRef = { current: false };

            const processQueue = async (queue) => {
                if (cancelledRef.current || queue.length === 0) {
                    return;
                }
                const [current, ...rest] = queue;
                await handleDecodeAddress(current);
                await delay(1000); 
                await processQueue(rest);
            };

            processQueue(itemsToDecode);

            return () => {
                cancelledRef.current = true;
            };
        }, [checklistData]);

        

    // const handleChecklistID = () => {
    //     const params = {
    //         checklist_id: currentChecklistId
    //     };
    //     const requestData = encryptData(params);
    //     const response = actions.checklistFetchData(requestData, false);
    //     response.then((result) => {
    //         response.then((result) => {
    //             if (result.data) {
    //                 console.log("Testing", result.data);
    //                 setChecklistData(result.data)
    //             }
    //         }).catch((error) => {
    //         });
    //     })
    // }

    const handleChecklistID = () => {
        const params = {
            checklist_id: currentChecklistId, // Assuming currentChecklistId is defined somewhere
        };
        const requestData = encryptData(params); // Encrypt the request if needed

        // Call your API to fetch checklist data
        const response = actions.checklistFetchData(requestData, false);

        response.then((result) => {
            if (result.data) {
                console.log("Checklist Data:", result.data);
                setChecklistData(result.data); // Set the fetched data to state
            }
        }).catch((error) => {
            console.error('Error fetching checklist data:', error);
        });
    };

    const handleNext = () => {
        handleSave('nextBtnClickHandler');
        if (currentIndex < questionnaireData.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const handleAnswer = (questionIndex, value, otherText = '') => {
        const questionInfo = questionnaireData[questionIndex];
        // console.log("questionInfo = ", questionInfo);
          if(questionInfo?.questionText === 'Whether customer address is where vehicle inspection is being done or not?'){
             console.log("Whether  value :", value);
             if(value === 'Yes' || value === 'No'){
              setWhetheCustomerStatus(value === 'No');
              setOtherTextData('');
             }
        } 

         if(questionInfo?.questionText === 'Current Address as per CAM visited?'){
              
             if(value === 'Yes' || value === 'No'){
              setCurrentAddressAsPerCAMVisited(value === 'No');
              setCurrentAddressAsPerCAMVisitedTextData('');
             }
        } 

        if(questionInfo?.questionText === 'Account Status'){              
             if(value === 'Regular' || value === 'OD'  || value === 'NPA'  || value === 'Skip' || value === 'EDA'){
              setAccountStatus(value === 'OD' || value === 'Skip'); 
             }
        } 
        
        if(questionInfo?.questionText?.trim() === 'Neighbour feedback In case Skip or OD Case'){
            setNeighbourFeedbackInCaseSkiporODCaseVal(value);
        } 

        if(questionInfo?.questionText?.trim() === 'Vehicle is being used by Customer or 3rd Party'){        
            setVehicleUsedBy(value); 
        } 

        if(questionInfo?.questionText?.trim() === 'Third party Name'){
            setThirdPartyNameVal(value);
        }
        if(questionInfo?.questionText?.trim() === 'Third Party Address'){
            setThirdPartyAddressVal(value);
        } 
        if(questionInfo?.questionText?.trim() === 'Third party Phone number'){
            setThirdPartyPhoneNumberVal(value);
        } 
        
        if(questionInfo?.questionText?.trim() === 'Vehicle Reading in KM'){
            setVehicleReadinginKMVal(value);
        } 
        if(questionInfo?.questionText?.trim() === 'Monthly earning/ Viability'){
            setMonthlyEarningViabilityVal(value);
        } 
        if(questionInfo?.questionText?.trim() === 'Any Performance issue with the Vehicle'){
            setAnyPerformanceIssueWithTheVehicleVal(value);
        } 

         if(questionInfo?.questionText?.trim() === 'Current Address of Guarantor as per CAM visited? Is it same ? If No Please mention the address'){              
             if(value === 'Yes' || value === 'No'){
              setCurrentAddressOfGuarantor(value === 'No');
              }
        }

        if(questionInfo?.questionText?.trim() === "Guarantor's Visited Address"){
            setGuarantorVisitedAddressVal(value);
        }
        
        if(questionInfo?.questionText === 'Do you want to refer someone for a loan?'){
             if(value === 'Yes' || value === 'No'){
              setDoYouWantToReferSomeoneForLoan(value === 'Yes');
              }
        } 

        if(questionInfo?.questionText?.trim() === 'Person name whom you want to refer?'){
            setPersonNameWhomYouWantToReferVal(value);
        } 

        if(questionInfo?.questionText?.trim() === 'Person contact details who you want to refer?'){
            setPersonContactDetailsWhoYouWantToReferVal(value);
        } 


        if(questionInfo?.questionText?.trim() === "Overall Feedback About the Visit for Customer"){
            setOverallFeedbackAbouttheVisitforCustomerVal(value); 
        }

         if(questionInfo?.questionText?.trim() === "Overall Feedback About the Visit for Guarantor/Co applicant"){
            setOverallFeedbackAbouttheVisitforGuarantorCoapplicantVal(value); 
         } 
        
        const updatedAnswers = [...answers];
        if(otherText === 'otherText'){

            // Ensure the slot is always an object
            if (!updatedAnswers[questionIndex] || typeof updatedAnswers[questionIndex] !== 'object') {
              //  updatedAnswers[questionIndex] = { updatedAnswers, otherText: '' };
            }
           // answers.otherText =  value;
            questionnaireData[questionIndex].otherText = value;
            setOtherTextData(value);
            setCurrentAddressAsPerCAMVisitedTextData(value);
        }     
       
         if(otherText === 'otherText'){
                // 
         }else{
            updatedAnswers[questionIndex] = value;
         }
        
         console.log("updatedAnswers :", updatedAnswers);
        setAnswers(updatedAnswers);

        setQuestionnaireData(questionnaireData);
        console.log("questionnaireData :", questionnaireData);
    };

    const handleSave = (actionHandler) => {
        console.log("Selected Answers:", answers);

        // Save answers to the database (convert to JSON if needed)
        const answersJSON = JSON.stringify(answers);
        if (currentChecklistId === '') {
            toast.error("Checklist id in null   ", {
                position: "top-right",
            });
            return;
        }

        const params = { 'id': currentChecklistId, 'answers': answersJSON, 'userRoleType': userRoleType, "lead_id": leadId,"api_calling_module":setSectionName };
        console.log("leadId :", leadId);

        const requestData = encryptData(params);
        const response = actions.updateLeadChecklistQuestionAnswer(requestData);

        response.then((result) => {
            // console.log("Promise resolved - add/edit question answer form:", result); 
            if (result.data.success === 1) {
                toast.success(result.data.message, {
                    position: "top-right",
                });
                // setShowLeadDetails(false);
                setTimeout(() => {
                    if (actionHandler !== 'nextBtnClickHandler') {
                        updateParentState(false);
                        fetchLeads();
                        setOpen(false);
                        backToChecklistsHandler();
                    }
                }, 1000);
            } else {
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }
        }).catch((error) => {
            //  console.error("Promise rejected - add/edit question answer form:", error);
            toast.error(error, {
                position: "top-right",
            });
        });
    };


    const updateChecklist = () => {
        const answersJSON = JSON.stringify(answers);
        if (currentChecklistId === '') {
            toast.error("Checklist id is null", {
                position: "top-right",
            });
            return;
        }
    if (intervalRef.current) {
        clearInterval(intervalRef.current);
    } 
    // Start a new interval 
   // intervalRef.current = setInterval(() => { 
    console.log("Outer api call  = ",lastFormSubmitStatus)
      //  if(lastFormSubmitStatus === true){
            console.log("Inner api call  = ",lastFormSubmitStatus)
             if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;

                    const leadIdVal = (leadId !=='' && leadId !== undefined) ? leadId : leadInfo?.data?.[0]?.id;
                    const checklistInfoId = checklistInfo?.id;


                // alert(allchecklistUploadIds);
                    const params = { 'id': currentChecklistId, 'answers': answersJSON, 'userRoleType': userRoleType, "lead_id": leadIdVal, "action": actionHandlerStatus, "fieldInvestigationFalg": fieldInvestigationFalg, "latitude": latitude, "longitude": longitude, "checklist_id": currentChecklistId,"otherTextData" : otherTextData ,"allchecklistUploadIds" : allchecklistUploadIds ,"api_calling_module":setSectionName};
                    console.log("params :", params);
    
                // alert(leadIdVal);

                    const requestData = encryptData(params);
                    const response = actions.updateFiChecklistQuestionAnswer(requestData);

                    response.then((result) => {
                        setLastFormSubmitStatus(false);
                        clearInterval(intervalRef.current);
                        // console.log("Promise resolved - add/edit question answer form:", result); 
                        if (result.data.success === 1) {
                            toast.success(result.data.message, {
                                position: "top-right",
                            });
                            // setShowLeadDetails(false);
                            setTimeout(() => { 
                                if (actionHandlerStatus !== 'nextBtnClickHandler') {
                                    updateParentState(false);
                                    fetchLeads();
                                    setOpen(false);
                                    backToChecklistsHandler();
                                }
                            }, 1000);
                        } else {
                            toast.error(result.data.message, {
                                position: "top-right",
                            });
                        }
                    }).catch((error) => {
                        //  console.error("Promise rejected - add/edit question answer form:", error);
                        toast.error(error, {
                            position: "top-right",
                        });
                    });

                }, (error) => {
                    toast.error('Error getting location:', error, {
                        position: "top-right",
                    });
                });
            } else {
                toast.error("Google location is not supported by this browser.", {
                    position: "top-right",
                });
            }
       // }

       //  }, 2000);

    }

    const handleSaveDraftAndFinal = (actionHandler) => { 

        console.log("checklistInfo = ",props.checklistInfo);
        console.log("checklistInfo 2 = ",checklistInfo);
        
        if( Number(camLatestStatus) === 1 &&  checklistInfo?.checklist_id !=='' && Number(checklistInfo?.checklist_id ) < 32){
            toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
                  position: "top-right",
              });
            //  alert('ifff');
              return; 
        }  

        const existingPhotos = checklistData.length;
        const newPhotos = selectedDocumentFiles.length;
        const totalPhotos = existingPhotos + newPhotos;

        if (actionHandler === "complete" && totalPhotos < 5) {
            toast.error("Please upload at least 5 photos before completing.");
            return;
        }
            
        setActionHandlerStatus(actionHandler);
        // console.log("actionHandler : ", actionHandler);
         onSubmit();   
        
    };

    

    const currentQuestion = questionnaireData[currentIndex];
    const backToChecklistsHandler = () => {
        setOpen(false);
        updateParentState(false);
    }

    const { register, handleSubmit } = useForm();
    const [fileSets, setFileSets] = useState([{
        uploadFile: [],
        fileComment: ''
    }]);

    useEffect(() => {
        if (props.checklistInfo) {
            setLeadId(props.checklistInfo.lead_id);
            setCurrentChecklistId(props.checklistInfo.id);

            if(props?.vitem?.linkedLeadDetails?.id !== '' && props?.vitem?.linkedLeadDetails?.id !== undefined){
                setLeadId(props?.vitem?.linkedLeadDetails?.id);
            } 
        }  
        console.log("questioniier props = ",props)
    }, [props.checklistInfo,leadId ]);

    const [canSubmit, setCanSubmit] = useState(false);
    useEffect(() => {
        setAllchecklistUploadIds('');
        setLastFormSubmitStatus(false);

        if (canSubmit ) {
            updateChecklist();
            // reset after calling
            setCanSubmit(false);
         }

    }, [canSubmit,allchecklistUploadIds,lastFormSubmitStatus]);

    const onSubmit = (data) => { 
        if (selectedDocumentFiles.length > 0 && fileSets.some(set => !set.fileComment.trim())
        ) {
            toast.error("Please enter Type of File.");
            return;
        }
        if(setSectionName === 're_fi_checklist' && accountStatus && (neighbourFeedbackInCaseSkiporODCaseVal?.trim() === '' || neighbourFeedbackInCaseSkiporODCaseVal?.trim() === undefined)){
            toast.error(`Neighbour feedback In case Skip or OD Case is required`); 
            
        }else if(setSectionName === 're_fi_checklist' && vehicleUsedBy === 'Third Party' && (thirdPartyNameVal?.trim() === '' || thirdPartyNameVal?.trim() === undefined)){
            toast.error(`Third Party Name is required`);    
        }else if(setSectionName === 're_fi_checklist' && vehicleUsedBy === 'Third Party' &&  (thirdPartyAddressVal?.trim() === '' || thirdPartyAddressVal?.trim() === undefined)){
            toast.error(`Third Party Address is required`);
            
        }else if(setSectionName === 're_fi_checklist' && vehicleUsedBy === 'Third Party' &&  (thirdPartyPhoneNumberVal?.trim() === '' || thirdPartyPhoneNumberVal?.trim() === undefined)){
            toast.error(`Third party Phone number is required`);
        }else if(setSectionName === 're_fi_checklist'  && (vehicleReadinginKMVal?.trim() === '' || vehicleReadinginKMVal?.trim() === undefined)){
            toast.error(`Vehicle Reading in KM is required`); 
            
        }else if(setSectionName === 're_fi_checklist'  && (monthlyEarningViabilityVal?.trim() === '' || monthlyEarningViabilityVal?.trim() === undefined)){
            toast.error(`Monthly Earning Viability is required`); 
        }else if(setSectionName === 're_fi_checklist'  && (anyPerformanceIssueWithTheVehicleVal?.trim() === '' || anyPerformanceIssueWithTheVehicleVal?.trim() === undefined)){
            toast.error(`Any Performance Issue With The Vehicle is required`);
            
         }else if(setSectionName === 're_fi_checklist'  &&  currentAddressOfGuarantor &&  (guarantorVisitedAddressVal?.trim() === '' || guarantorVisitedAddressVal?.trim() === undefined)){
            toast.error(`Guarantor Visited Address is required`); 
            
        }else if(setSectionName === 're_fi_checklist' && doYouWantToReferSomeoneForLoan &&    (personNameWhomYouWantToReferVal?.trim() === '' || personNameWhomYouWantToReferVal?.trim() === undefined)){
            toast.error(`Person Name Whom You Want To Refer is required`);
            
        }else if(setSectionName === 're_fi_checklist' && doYouWantToReferSomeoneForLoan  &&  (personContactDetailsWhoYouWantToReferVal?.trim() === '' || personContactDetailsWhoYouWantToReferVal?.trim() === undefined)){
            toast.error(`Person Contact Details Who You Want To Refer is required`);  
            
         }else if(setSectionName === 're_fi_checklist'   &&   (overallFeedbackAbouttheVisitforCustomerVal?.trim() === '' || overallFeedbackAbouttheVisitforCustomerVal?.trim() === undefined)){
            toast.error(`Overall Feedback About the Visit for Customer is required`);     
        }else if(setSectionName === 're_fi_checklist'   &&  (overallFeedbackAbouttheVisitforGuarantorCoapplicantVal?.trim() === '' || overallFeedbackAbouttheVisitforGuarantorCoapplicantVal?.trim() === undefined)){
            toast.error(`Overall Feedback About the Visit for Guarantor/Co applicant is required`); 
 
        }else{ 
        
        const params = fileSets.map(set => ({
            upload_file: set.uploadFile,
            document_file: selectedDocumentFiles,
            file_comment: set.fileComment,
            lead_id: leadId,
            checklist_id: currentChecklistId,
            brief: "checklist",
        }));
        console.log('Form Data:', params);
        const requestData = encryptData(params);
        const response = actions.addEditUploadFile(requestData);
        response.then((result) => {
           // setLeadId();
             setLastFormSubmitStatus(true);
             setCanSubmit(true);
             console.log('Result ->', result);

             const checklistUploadIds = result?.data?.checklist_upload_ids || [];
              console.log('checklistUploadIds ->', checklistUploadIds);

              const commaSeparatedIds = checklistUploadIds.join(",");
              setAllchecklistUploadIds(commaSeparatedIds);
            
            // toast.success('Add Record successfully', {
            //     position: 'top-right',
            // });
        });

    }
    };

    const handleUploadFileChange = (e, index) => {
        const files = Array.from(e.target.files);
        const base64Files = [];
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    const newFileSets = [...fileSets];
                    newFileSets[index].uploadFile = base64Files;
                    setFileSets(newFileSets);
                    console.log('Updated uploadFile:', base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const handleCommentChange = (e, index) => {
        const newFileSets = [...fileSets];
        newFileSets[index].fileComment = e.target.value;
        setFileSets(newFileSets);
    };

    const addMoreFields = () => {
        setFileSets([...fileSets, { uploadFile: [], fileComment: '' }]);
    };

    const deleteFileSet = (index) => {
        const newFileSets = fileSets.filter((_, i) => i !== index);
        setFileSets(newFileSets);
    };

    const handleDownload = (fileUrl, fileName) => {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // const downloadExcel = () => {
    //     const table = document.getElementById('DynamicExcelFile');
    //     const ws = XLSX.utils.table_to_sheet(table);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    //     const fileName = 'New FI Report.xlsx';
    //     XLSX.writeFile(wb, fileName);
    // };


    const downloadExcel = async () => {
            const table = document.getElementById('DynamicExcelFile');
    
            TableToExcel.convert(table, {
                name: 'FI-Checklist.xlsx',
                sheet: {
                    name: 'FI-Checklist',
                },
            });
        };

    const handleDelete = (uidToDelete) => {
        setImageDetails(prevDetails => {
          const target = prevDetails.find(img => img.uid === uidToDelete);
          // 🧹 Revoke object URLs to prevent memory leaks
          if (target?.previewUrl) {
            URL.revokeObjectURL(target.previewUrl);
          }
          if (target?.tempPreviewUrl && target.tempPreviewUrl !== target.previewUrl) {
            URL.revokeObjectURL(target.tempPreviewUrl);
          }
          // 🧼 Filter out the deleted image
          const newDetails = prevDetails.filter(img => img.uid !== uidToDelete);
          // 🔄 Sync related states
          setPreviews(newDetails.map(img => img.previewUrl));
          setCompressedFiles(prev =>
            prev.filter(img => img.uid !== uidToDelete)
          );
          setSelectedDocumentFiles(prev =>
            prev.filter(img => img.uid !== uidToDelete)
          );
          setUploadProgressMap(prev => {
            const newMap = { ...prev };
            delete newMap[uidToDelete];
            return newMap;
          });
          return newDetails;
        });
      };
    
      const handleDocumentFileChange = (e) => {
          const files = Array.from(e.target.files);
          const base64Files = [];
    
          files.forEach((file) => {
              const reader = new FileReader();
              reader.onload = (event) => {
                  const base64Data = event.target.result;
                  const fileName = file.name;
                  base64Files.push({  uid: uuidv4(), file: base64Data, name: fileName });
                  if (base64Files.length === files.length) {
                      setSelectedDocumentFiles(base64Files);
                  }
              };
              reader.readAsDataURL(file);
          });
      };
    
      const checkDocumentType = (data) => {
        return data.startsWith("dynamicDocument^");
      };
    
    //   const xhandleImageChange = async (event) => {
    //     const files = Array.from(event.target.files);
    //     if (!files.length) return;
    //     const limit = pLimit(1);
    //     const options = {
    //       maxSizeMB: 1,
    //       useWebWorker: true,
    //       maxWidthOrHeight: 1024,
    //     };
    //     const fileUidMap = [];
    //     // Step 1: Add temporary placeholders and previews
    //     files.forEach((file) => {
    //       const uid = uuidv4();
    //       const tempUrl = URL.createObjectURL(file);
    //       fileUidMap.push({ uid, file });
    //       setImageDetails(prev => [
    //         ...prev,
    //         {
    //           uid,
    //           name: file.name,
    //           loading: true,
    //           tempPreviewUrl: tempUrl,
    //           previewUrl: tempUrl,
    //           rawFile: file,
    //         }
    //       ]);
    //       // Add placeholder for selectedDocumentFiles as well
    //       setSelectedDocumentFiles(prev => [
    //         ...prev,
    //         {
    //           uid,
    //           name: file.name,
    //           tempPath: null // Placeholder, will update after compression
    //         }
    //       ]);
    //     });
    
    //     const compressAndStore = useCallback(
    //         async ({ uid, file }) => {
    //             try {
    //             // ---- GPS ko ORIGINAL file se nikalo, compression se PEHLE ----
    //             // (compression canvas re-encode karta hai jo EXIF/GPS strip kar deta hai)
    //             let latitude = null;
    //             let longitude = null;
    //             try {
    //                 const gps = await exifr.gps(file); // JPG aur HEIC dono ke liye kaam karta hai
    //                 if (gps && gps.latitude && gps.longitude) {
    //                 latitude = gps.latitude;
    //                 longitude = gps.longitude;
    //                 }
    //             } catch (gpsErr) {
    //                 // GPS nahi mila / photo mein location off thi — koi baat nahi, aage badho
    //             }

    //             const isHeic = /\.(heic|heif)$/i.test(file.name) || /heic|heif/i.test(file.type || '');

    //             let fileToUpload = file;
    //             let previewUrl = null;

    //             if (isHeic) {
    //                 // Canvas HEIC decode nahi kar sakta — compression skip, original hi upload
    //                 setOverlayState(prev => ({ ...prev, message: `Uploading ${file.name}...` }));
    //             } else {
    //                 setOverlayState(prev => ({ ...prev, message: `Compressing ${file.name}...` }));
    //                 fileToUpload = await imageCompression(file, options);
    //                 previewUrl = URL.createObjectURL(fileToUpload);
    //                 setOverlayState(prev => ({ ...prev, message: `Uploading ${file.name}...` }));
    //             }

    //             const formData = new FormData();
    //             formData.append("folderId", folderId);
    //             formData.append("file", fileToUpload, file.name);
    //             formData.append("uid", uid);

    //             const result = await actions.uploadTempFile(formData, {
    //                 headers: { "Content-Type": "multipart/form-data" },
    //                 onUploadProgress: ev => {
    //                 const percent = Math.round((ev.loaded * 100) / (ev.total || 1));
    //                 setOverlayState(prev => ({ ...prev, progressPercent: percent }));
    //                 }
    //             });

    //             const { tempPath } = result.file;

    //             setImageDetails(prev =>
    //                 prev.map(item =>
    //                 item.uid === uid
    //                     ? {
    //                         ...item,
    //                         compressedFile: fileToUpload,
    //                         previewUrl: previewUrl || item.previewUrl,
    //                         loading: false,
    //                         originalSize: (file.size / 1024).toFixed(2),
    //                         compressedSize: (fileToUpload.size / 1024).toFixed(2)
    //                     }
    //                     : item
    //                 )
    //             );

    //             // tempPath ke saath GPS bhi save karo — ye hi document_file mein backend jayega
    //             setSelectedDocumentFiles(prev =>
    //                 prev.map(item => (item.uid === uid ? { ...item, tempPath, latitude, longitude } : item))
    //             );

    //             setOverlayState(prev => ({
    //                 ...prev,
    //                 completed: Math.min(prev.completed + 1, prev.total),
    //                 progressPercent: 0
    //             }));

    //             return { ok: true, uid };
    //             } catch (err) {
    //             setOverlayState(prev => ({
    //                 ...prev,
    //                 completed: Math.min(prev.completed + 1, prev.total),
    //                 failedCount: prev.failedCount + 1
    //             }));
    //             return { ok: false, uid, file, error: err };
    //             }
    //         },
    //         [folderId, actions]
    //         );
    //     await Promise.all(fileUidMap.map(file => limit(() => compressAndStore(file))));
    //   };
     const options = { maxSizeMB: 1, useWebWorker: true, maxWidthOrHeight: 1024 };
    
    // Reusable for retry
    const compressAndStore = useCallback(
      async ({ uid, file }) => {
        try {
          // ---- GPS ko ORIGINAL file se nikalo, compression se PEHLE ----
          let latitude = null;
          let longitude = null;
          try {
            const gps = await exifr.gps(file);
            if (gps && gps.latitude && gps.longitude) {
              latitude = gps.latitude;
              longitude = gps.longitude;
            }
          } catch (gpsErr) {
            // GPS nahi mila — koi baat nahi, aage badho
          }

          const isHeic = /\.(heic|heif)$/i.test(file.name) || /heic|heif/i.test(file.type || '');

          let fileToUpload = file;
          let previewUrl = null;

          if (isHeic) {
            setOverlayState(prev => ({ ...prev, message: `Uploading ${file.name}...` }));
          } else {
            setOverlayState(prev => ({ ...prev, message: `Compressing ${file.name}...` }));
            fileToUpload = await imageCompression(file, options);
            previewUrl = URL.createObjectURL(fileToUpload);
            setOverlayState(prev => ({ ...prev, message: `Uploading ${file.name}...` }));
          }

          const formData = new FormData();
          formData.append("folderId", folderId);
          formData.append("file", fileToUpload, file.name);
          formData.append("uid", uid);

          const result = await actions.uploadTempFile(formData, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: ev => {
              const percent = Math.round((ev.loaded * 100) / (ev.total || 1));
              setOverlayState(prev => ({ ...prev, progressPercent: percent }));
            }
          });

          const { tempPath } = result.file;

          setImageDetails(prev =>
            prev.map(item =>
              item.uid === uid
                ? {
                    ...item,
                    compressedFile: fileToUpload,
                    previewUrl: previewUrl || item.previewUrl,
                    loading: false,
                    originalSize: (file.size / 1024).toFixed(2),
                    compressedSize: (fileToUpload.size / 1024).toFixed(2)
                  }
                : item
            )
          );

          setSelectedDocumentFiles(prev =>
            prev.map(item => (item.uid === uid ? { ...item, tempPath, latitude, longitude } : item))
          );

          setOverlayState(prev => ({
            ...prev,
            completed: Math.min(prev.completed + 1, prev.total),
            progressPercent: 0
          }));

          return { ok: true, uid };
        } catch (err) {
          setOverlayState(prev => ({
            ...prev,
            completed: Math.min(prev.completed + 1, prev.total),
            failedCount: prev.failedCount + 1
          }));
          return { ok: false, uid, file, error: err };
        }
      },
      [folderId, actions]
    );
    
    const handleImageChange = async event => {
      const files = Array.from(event.target.files || []);
      if (!files.length) return;
    
      const limit = pLimit(1);
      const fileUidMap = files.map(f => ({ uid: uuidv4(), file: f }));
    
      setOverlayState({
        visible: true,
        total: files.length,       // original total stays here
        completed: 0,              // start fresh
        failedCount: 0,
        progressPercent: 0,
        message: "Starting...",
        retryFiles: []
      });
    
      // placeholders
      fileUidMap.forEach(({ uid, file }) => {
        const tempUrl = URL.createObjectURL(file);
        setImageDetails(prev => [
          ...prev,
          { uid, name: file.name, loading: true, tempPreviewUrl: tempUrl, previewUrl: tempUrl, rawFile: file }
        ]);
        setSelectedDocumentFiles(prev => [...prev, { uid, name: file.name, tempPath: null }]);
      });
    
      const results = await Promise.all(fileUidMap.map(f => limit(() => compressAndStore(f))));
      const failed = results.filter(r => !r.ok).map(r => ({ uid: r.uid, file: r.file }));
    
      if (failed.length) {
        setOverlayState(prev => ({
          ...prev,
          message: `${failed.length} failed. Click retry.`,
          retryFiles: failed
        }));
      } else {
        setOverlayState(prev => ({ ...prev, message: "All files proccessed" }));
        setTimeout(() => {
                    setOverlayState(o => ({ ...o, visible: false }));
                }, 500);
          }
    };
    
    const retryFailedUploads = async () => {
      const retryList = overlayState.retryFiles || [];
      if (!retryList.length) return;
    
      setOverlayState(prev => ({
        ...prev,
        message: "Retrying failed files...",
        failedCount: 0,
        progressPercent: 0,
        retryFiles: []
        // NOTICE: we do NOT reset `completed` here
      }));
    
      const limit = pLimit(1);
      const results = await Promise.all(retryList.map(f => limit(() => compressAndStore(f))));
      const stillFailed = results.filter(r => !r.ok);
    
      if (stillFailed.length) {
        setOverlayState(prev => ({
          ...prev,
          message: `${stillFailed.length} still failed`,
          retryFiles: stillFailed.map(s => ({ uid: s.uid, file: s.file })),
          failedCount: stillFailed.length
        }));
      } else {
        setOverlayState(prev => ({ ...prev, message: "Retry successful" }));
        setTimeout(() => {
                    setOverlayState(o => ({ ...o, visible: false }));
                }, 500);
          }
    }; 
    return (
        <div>
            <div className='d-flex flex-md-row flex-column align-md-items-center align-items-start justify-content-between mt-3'>                
            {checklistInfo.check_list_name !=='' && setSectionName !== 'vehicle_inspection_form' && (
                    <>
                    <h5 className='fw-bold mb-3 order-md-1 mb-0 order-2'>
                    Checklist : {checklistInfo.check_list_name}</h5>
                    </>
                )}
                <button onClick={backToChecklistsHandler} onKeyDown={backToChecklistsHandler} className='btn fw-bold mb-3 bg-info text-white py-1 px-2 rounded order-md-2 order-1 btn-auto'>Back to List</button> 
            </div>
            <div className='row mb-2'>
                <div className="col-6 text-start">
                    <button
                        disabled={leadStatusFlag === true} className={fieldInvestigationFalg && showButtonOrNot ? "btn btn-success d-none btn-auto btn-auto" : "btn btn-success btn-auto btn-auto"} onClick={() => handleSaveDraftAndFinal("draft")}>
                        Save As Draft
                    </button>
                </div>
                <div className={fieldInvestigationFalg ? "d-none col-6 text-end" : "col-6 text-end"}>
                    <button
                        disabled={leadStatusFlag === true}
                        className="btn btn-success btn-auto"
                        onClick={() => handleSaveDraftAndFinal("complete")}
                    >
                        Complete
                    </button>
                </div>
                <div className="col-6 text-end">
                    <button
                        disabled={leadStatusFlag === true}
                        className={fieldInvestigationFalg ? "btn btn-primary" : "d-none btn btn-primary"}
                        onClick={() => handleSaveDraftAndFinal("final")}
                    >
                        Final Save
                    </button>
                </div>
                <div className="col-6 text-end" style={{margin: '0.5rem 0rem'}}>
                <button className={(setSectionName === 'post_disbursal_document') ? "btn btn-info text-white d-none" : "btn btn-info text-white"} onClick={() => downloadExcel()}>Export</button>
                </div> 
            </div>
            <div>
                {questionnaireData.map((currentQuestion, questionIndex) => (
                    <div key={questionIndex} className='question-wrap'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-group'>
                                    <h6 className='d-flex lh-base mb-2'><span className='h6 lh-base fw-bold opacity-100 mb-0'>Q{questionIndex + 1}.&nbsp;</span> {currentQuestion.questionText} {currentQuestion?.questionText?.trim() === 'Neighbour feedback In case Skip or OD Case' && accountStatus && (
                                        <span className="text-danger">*</span> 
                                    )}</h6>
                                </div>
                            </div>
                            <div className='col-md-12 questions'>
                                <span className='mb-1'>Answer Option</span>
                                <div className='row q-row'>
                                    {currentQuestion.answerType === "checkbox" ? (
                                        currentQuestion.answerOptions.map((option, optionIndex) => (
                                            <div className="col-md-3" key={optionIndex}>
                                                <div className="question-options mb-md-0 mb-2">
                                                    <label htmlFor="check" className='d-flex align-items-center'>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            value={option}
                                                            checked={(answers[questionIndex] || []).includes(option)}
                                                            onChange={(e) => {
                                                                const selectedOptions = answers[questionIndex] || [];
                                                                if (e.target.checked) {
                                                                    selectedOptions.push(option);
                                                                } else {
                                                                    const indexToRemove = selectedOptions.indexOf(option);
                                                                    if (indexToRemove !== -1) {
                                                                        selectedOptions.splice(indexToRemove, 1);
                                                                    }
                                                                }
                                                                handleAnswer(questionIndex, selectedOptions);
                                                            }}
                                                        />
                                                        <span className='ps-2 mb-0'>{option}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        ))
                                    ) : currentQuestion.answerType === "input" ? (
                                        <div className='px-2'>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={answers[questionIndex]}
                                                onChange={(e) => handleAnswer(questionIndex, e.target.value)}
                                            />
                                        </div>
                                    ) : currentQuestion.answerType === "radio" ? (

                                        <> 
                                       
                                       { currentQuestion.answerOptions.map((option, optionIndex) => (
                                            <div className={
                                                leadInfo?.data?.[0]?.collectedOverdue < 5000 &&
                                                currentQuestion?.questionText?.toLowerCase() === "is overdue collected?"
                                                ? "disabled-class col-md-3"
                                                : "enabled-class col-md-3"
                                            }  key={optionIndex}>

                                                <div  className={
                                                leadInfo?.data?.[0]?.collectedOverdue < 5000 &&
                                                currentQuestion?.questionText?.toLowerCase() === "is overdue collected?"
                                                ? "disabled-class question-options mb-md-0 mb-2"
                                                : "enabled-class question-options mb-md-0 mb-2" }
                                                >
                                                    <label htmlFor="radio" className='d-flex align-items-center'>
                                                        <input
                                                            type="radio"
                                                             className={
                                                            leadInfo?.data?.[0]?.collectedOverdue < 5000 &&
                                                            currentQuestion?.questionText?.toLowerCase() === "is overdue collected?"
                                                            ? "disabled-class form-check-input"
                                                            : "enabled-class form-check-input" }
                                                            value={option}
                                                            checked={answers[questionIndex] === option}
                                                            onChange={() => handleAnswer(questionIndex, option)} 
                                                            disabled={
                                                            leadInfo?.data?.[0]?.collectedOverdue < 5000 &&
                                                            currentQuestion?.questionText?.toLowerCase() === "is overdue collected?"}
                                                        />
                                                        <span className='ps-2 mb-0'>{option}</span>
                                                    </label>
                                                </div>

                                               
                                            </div>
                                        ))}
                                        

                                         { ( (whetheCustomerStatus || answers[questionIndex] === 'No') && currentQuestion?.questionText === 'Whether customer address is where vehicle inspection is being done or not?') && (
                                            <>
                                            <div className='px-2 mt-2'>
                                             <span className='mb-1'>Address</span>
                                             <textarea
                                                value={currentQuestion?.otherText}
                                                placeholder=''
                                                onChange={(e) => handleAnswer(questionIndex, e.target.value, 'otherText')}
                                                className="form-control"
                                            />
                                            </div>
                                            </>
                                        )}


                                        { ( (currentAddressAsPerCAMVisited || answers[questionIndex] === 'No') && currentQuestion?.questionText === 'Current Address as per CAM visited?') && (
                                            <>
                                            <div className='px-2 mt-2'>
                                             <span className='mb-1'>What is the current address?</span>
                                             <textarea
                                                value={currentQuestion?.otherText}
                                                placeholder=''
                                                onChange={(e) => handleAnswer(questionIndex, e.target.value, 'otherText')}
                                                className="form-control"
                                            />
                                            </div>
                                            </>
                                        )}

                                        
                                        </>
                                    ) : (
                                        <div className='px-2'>
                                            <textarea
                                                value={answers[questionIndex]}
                                                onChange={(e) => handleAnswer(questionIndex, e.target.value)}
                                                className="form-control"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {/* ************************************************************* */}
                {/* Start the Portion */}
                <div style={{ marginBottom: '1rem' }}>
                    <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
                        {fileSets.map((fileSet, index) => (
                            <div className="row" key={index}>
                                <div style={{ display: 'none' }}>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor={`upload_file_${index}`}>
                                                <span>File Upload</span>
                                                <input
                                                    type='file'
                                                    id={`upload_file_${index}`}
                                                    name={`upload_file_${index}`}
                                                    className='form-control'
                                                    multiple
                                                    onChange={(e) => handleUploadFileChange(e, index)}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-2" style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                                        <label htmlFor="dsd" />
                                        <button style={{ height: '2rem' }} type="button" className="btn btn-danger btn-auto" onClick={() => deleteFileSet(index)}>X</button>
                                    </div>
                                </div>

 <div className="col-md-6">
        
        <div style={{ display: 'none', alignItems: 'center', textAlign: 'center', margin: '20px 0' }}>
            <hr style={{ flex: 1, border: 'none', borderTop: '1px solid' }} />
            <span style={{ padding: '0 10px', color: '#888' }}>OR</span>
            <hr style={{ flex: 1, border: 'none', borderTop: '1px solid' }} />
        </div>
        { /*  SAMPLE CODE  :  START */}
        <div style={{ paddingTop: "1px", paddingBottom: "10px" }} title={isMobile ? "Mobile" : "Laptop/Desktop"} >
            <div style={{ display: 'flex', gap: '10px', marginBottom: 20 }}>
            <button type="button" className="btn btn-warning" onClick={() => fileInputRef.current.click()}>Select Photos</button>
            {isMobile && (
                <button type="button" className="btn btn-success" onClick={() => cameraInputRef.current.click()}>Open Camera</button>)}
            {preloaderStatus && (
                <>
                <div className="spinner-border small-preloader mt-2" role="status" >
                    <span className="visually-hidden">&nbsp;</span></div>
                </>
            )}
            </div>
            {/* Hidden file inputs */}
            <input
            type="file"
            accept="image/*"
            multiple
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleImageChange}
            />
            <input
            type="file"
            accept="image/*"
            capture="environment"
            multiple
            ref={cameraInputRef}
            style={{ display: 'none' }}
            onChange={handleImageChange}
            />
            {/* Preview compressed images */}
            
{overlayState.visible && (
<div style={overlayStyles.container}>
    <div style={overlayStyles.box}>
    <button
        style={overlayStyles.closeBtn}
        onClick={() => setOverlayState(prev => ({ ...prev, visible: false }))}
    >
        ✕
    </button>
    <h4>File Compression Progress</h4>
    <p>{overlayState.message}</p>
    <p>
        {overlayState.completed}/{overlayState.total} processed
    </p>
    <progress
        value={overlayState.progressPercent}
        max="100"
        style={{ width: "100%" }}
    />
    {overlayState.failedCount > 0 && (
        <>
        <p style={{ color: "red" }}>
            {overlayState.failedCount} failed
        </p>
        <button onClick={retryFailedUploads}>Retry Failed</button>
        </>
    )}
    </div>
</div>
)}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px' }}>
            {imageDetails.map((img) => (
                <div key={img.uid} style={{ position: 'relative' }}>
                <img
                    src={img.previewUrl || img.tempPreviewUrl}
                    alt={`preview-${img.uid}`}
                    style={{
                    width: '100%',
                    height: 80,
                    objectFit: 'cover',
                    borderRadius: 8,
                    opacity: img.loading ? 0.5 : 1,
                    transition: 'opacity 0.3s ease-in-out',
                    }}
                />
                {img.loading && (
                    <div style={{ marginTop: 6 }}>
                    <div
                        style={{
                        background: '#e0e0e0',
                        height: 6,
                        borderRadius: 3,
                        overflow: 'hidden',
                        }}
                    >
                        <div
                        style={{
                            width: '100%',
                            background: 'linear-gradient(90deg, #ccc 25%, #aaa 50%, #ccc 75%)',
                            backgroundSize: '200% 100%',
                            animation: 'loadingAnimation 1.5s infinite linear',
                            height: '100%',
                        }}
                        />
                    </div>
                    <div style={{ fontSize: 10 }}>Compressing...</div>
                    </div>
                )}
                {!img.loading && (
                    <div style={{ fontSize: 12, marginTop: 6 }}>
                    Original: {img.originalSize} KB<br />
                    Compressed: {img.compressedSize} KB
                    {uploadProgressMap[img.uid] !== undefined && (
                        <div style={{ marginTop: 6 }}>
                        <div
                            style={{
                            background: '#e0e0e0',
                            height: 6,
                            borderRadius: 3,
                            overflow: 'hidden',
                            }}
                        >
                            <div
                            style={{
                                width: `${uploadProgressMap[img.uid]}%`,
                                background:
                                uploadProgressMap[img.uid] < 100 ? '#007bff' : '#28a745',
                                height: '100%',
                                transition: 'width 0.3s',
                            }}
                            />
                        </div>
                        <div style={{ fontSize: 10 }}>
                            {uploadProgressMap[img.uid] < 100
                            ? `${uploadProgressMap[img.uid]}% uploading`
                            : 'Uploaded'}
                        </div>
                        </div>
                    )}
                    </div>
                )}
                <button
                    aria-label="Delete image"
                    tabIndex={0}
                    onClick={() => handleDelete(img.uid)}
                    type="button"
                    style={{
                    position: 'absolute',
                    top: 2,
                    right: 2,
                    background: '#ff5555',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '50%',
                    width: 20,
                    height: 20,
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    lineHeight: '3px',
                    }}
                > 
                    ×
                </button>
                </div>
            ))}
            {/* Move this out to top-level in your component or in global CSS */}
            <style>
                {`
@keyframes loadingAnimation {
0% { background-position: 200% 0; }
100% { background-position: -200% 0; }
}
`}
            </style>
            </div>
        </div>
        { /*  SAMPLE CODE  :  END */}
        </div>  

                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <label htmlFor={`file_comment_${index}`}>
                                            <span>Type of file</span>
                                            <textarea
                                                id={`file_comment_${index}`}
                                                className='form-control'
                                                name={`file_comment_${index}`}
                                                placeholder="Comment Something"
                                                value={fileSet.fileComment}
                                                onChange={(e) => handleCommentChange(e, index)}
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        ))}


                        <div className="col-md-12 d-none" style={{ display: 'none', justifyContent: 'end', alignItems: 'center', height: '2rem', marginTop: '0.2rem' }} >
                            <div className="form-group">
                                <button type="button" className="btn btn-success" onClick={addMoreFields}>Add More</button>
                            </div>
                        </div>
                    </form>
                </div>
                {/* table Start  */} 
                <div className='table-wrap' style={{padding: '15px'}}>
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>File Upload</th>
                                <th>File Comment</th>
                                <th>Latitude</th>
                                <th>Longitude</th>
                                <th>Address</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {checklistData.length > 0 ? (
                                checklistData.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <a href={item.file_url} target="_blank" rel="noopener noreferrer"> {item.upload_file} </a>
                                        </td>
                                        <td>{item.file_comment}</td>
                                       <td>
                                            {item.latitude ? (
                                                <a
                                                    href={`https://www.google.com/maps?q=${item.latitude},${item.longitude}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                                                >
                                                    {item.latitude}
                                                </a>
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>

                                        <td>
                                            {item.longitude ? (
                                                <a
                                                    href={`https://www.google.com/maps?q=${item.latitude},${item.longitude}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                                                >
                                                    {item.longitude}
                                                </a>
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>
                                        <td style={{ minWidth: '350px', maxWidth: '450px' }}>
                                            {decodedAddresses[item.id] ? (
                                                <span
                                                    title={`Source: ${decodedAddresses[item.id].source}`}
                                                    style={{ cursor: 'help', borderBottom: '1px dotted #999' }}
                                                >
                                                    {decodedAddresses[item.id].address}
                                                </span>
                                            ) : item.latitude && item.longitude ? (
                                                decodingIds[item.id] ? (
                                                    <span className="text-muted">Decoding...</span>
                                                ) : (
                                                    <span className="text-muted">Fetching address...</span>
                                                )
                                            ) : (
                                                <span className="text-muted">No GPS data</span>
                                            )}
                                        </td>
                                        <td>
                                            <button style={{ height: '2rem' }} type="button" className="btn btn-danger btn-auto" onClick={() => handleDeleteRow(item.id)}>X</button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: 'center' }}>No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {/* tale end */}

                {/* End the Portion */}
                {/* ************************************************************* */}

                <div className='row'>

                    <div className="col-6 text-start">
                        <button disabled={leadStatusFlag === true} className={fieldInvestigationFalg && showButtonOrNot ? "btn btn-success d-none btn-auto" : "btn btn-success btn-auto"} onClick={() => handleSaveDraftAndFinal("draft")}>Save As Draft</button>
                    </div>

                    <div className={fieldInvestigationFalg ? "d-none col-6 text-end" : "col-6 text-end"}>
                        <button disabled={leadStatusFlag === true} className="btn btn-success btn-auto" onClick={() => handleSaveDraftAndFinal("complete")}>Complete</button>
                    </div>

                    <div className="col-6 text-end">
                        <button disabled={leadStatusFlag === true} className={fieldInvestigationFalg ? "btn btn-primary btn-auto" : "d-none btn btn-primary btn-auto"} onClick={() => handleSaveDraftAndFinal("final")}>Final Save</button>
                    </div>
                </div>

            </div>



            <div className="table--wrap table-responsive d-none">
                        <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"
                            data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
                            {checklistInfo.check_list_name === 'FI DCO' && (
                            <tbody>                            
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Field Investigation Details: {checklistInfo.check_list_name} </th>
                                </tr>
                                <tr>
                                    {console.log("questionsExcelDataPagination", questions)}
                                    <td colSpan="1" data-f-bold="true"><b>Name of FI Manager</b></td>
                                    <td colSpan="2">{questions[0] && questions[0].userAnswers && questions[0].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Employee code</td>
                                    <td colSpan="2">{questions[1] && questions[1].userAnswers && questions[1].userAnswers[0]}</td>

                                    <td colSpan="1" data-f-bold="true">Date of FI</td>
                                    <td colSpan="3">{questions[2] && questions[2].userAnswers && questions[2].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Time</td>
                                    <td colSpan="2">{questions[3] && questions[3].userAnswers && questions[3].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Applicant Name </td>
                                    <td colSpan="2">{questions[4] && questions[4].userAnswers && questions[4].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Phone</td>
                                    <td colSpan="2">{questions[6] && questions[6].userAnswers && questions[6].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Applicant Type</td>
                                    <td colSpan="1">{questions[7] && questions[7].userAnswers && questions[7].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Date of Birth</td>
                                    <td colSpan="1">{questions[5] && questions[5].userAnswers && questions[5].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Highest Education Level</td>
                                    <td colSpan="2">{questions[8] && questions[8].userAnswers && questions[8].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Marital Status</td>
                                    <td colSpan="1">{questions[9] && questions[9].userAnswers && questions[9].userAnswers[0]}</td>
                                    <td colSpan="2">&nbsp;</td>
                                    <td colSpan="2">&nbsp;</td>
                                </tr>
                              <tr>
                                    <td colSpan="1" data-f-bold="true">Person Met</td>
                                    <td colSpan="1">{questions[10] && questions[10].userAnswers && questions[10].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Relation with Applicant</td>
                                    <td colSpan="1">{questions[11] && questions[11].userAnswers && questions[11].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Living Since</td>
                                    <td colSpan="1">{questions[18] && questions[18].userAnswers && questions[18].userAnswers[0]}</td>
                                    <td colSpan="3" data-f-bold="true">Distance from Dealer Branch/Service centre</td>
                                    <td colSpan="1">{questions[21] && questions[21].userAnswers && questions[21].userAnswers[0]}</td>
                                </tr>
                                   <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Status</td>
                                    <td colSpan="3" >{questions[12] && questions[12].userAnswers && questions[12].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Locality & Traceability(Should not be in negative area and ease of access)</td>
                                    <td colSpan="2">{questions[19] && questions[19].userAnswers && questions[19].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Standard of Living</td>
                                    <td colSpan="2">{questions[20] && questions[20].userAnswers && questions[20].userAnswers[0]}</td>
                                    <td colSpan="2" data-f-bold="true">Commercial Driving Experience</td>
                                    <td colSpan="5">{questions[22] && questions[22].userAnswers && questions[22].userAnswers[0]}</td>
                                </tr>
                              <tr>
                                    <td colSpan="1" data-f-bold="true">Current Address
                                    </td>
                                    <td colSpan="12">{questions[13] && questions[13].userAnswers && questions[13].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Landmark</td>
                                    <td colSpan="2">{questions[14] && questions[14].userAnswers && questions[14].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">City</td>
                                    <td colSpan="2">{questions[15] && questions[15].userAnswers && questions[15].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">State</td>
                                    <td colSpan="2">{questions[16] && questions[16].userAnswers && questions[16].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Postal Code</td>
                                    <td colSpan="3">{questions[17] && questions[17].userAnswers && questions[17].userAnswers[0]}</td>
                                </tr>
                                
                                  <tr>
                                    <td colSpan="1" data-f-bold="true">First Neighbour Name</td>
                                    <td colSpan="5">{questions[23] && questions[23].userAnswers && questions[23].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Second Neighbour Name</td>
                                    <td colSpan="6">{questions[26] && questions[26].userAnswers && questions[26].userAnswers[0]}</td>
                                </tr>
                               <tr>
                                    <td colSpan="1" data-f-bold="true">First Neighbour Contact No.</td>
                                    <td colSpan="5">{questions[24] && questions[24].userAnswers && questions[24].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Second Neighbour Contact No.</td>
                                    <td colSpan="6">{questions[27] && questions[27].userAnswers && questions[27].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">First Neighbour Feedback</td>
                                    <td colSpan="5">{questions[25] && questions[25].userAnswers && questions[25].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Second Neighbour Feedback</td>
                                    <td colSpan="6">{questions[28] && questions[28].userAnswers && questions[28].userAnswers[0]}</td>
                                </tr>                            
                                <tr>
                                    <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Route MAP</th>
                                </tr>
                                <tr>
                                    <td colSpan="12">{questions[30] && questions[30].userAnswers && questions[30].userAnswers[0]}</td>
                                </tr>
                               <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Applicant - Vehicle Deployment</th>
                                </tr>
                                <tr>
                                    <td colSpan="13">{questions[29] && questions[29].userAnswers && questions[29].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Profile Feedback</th>
                                </tr>
                                <tr>
                                    <th colSpan="13">{questions[31] && questions[31].userAnswers && questions[31].userAnswers[0]}</th>
                                </tr>
                            </tbody>
                            )} 
                            {checklistInfo.check_list_name === 'FI DCO Co-Applicant' && (
                            <tbody>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Field Investigation Details: {checklistInfo.check_list_name} </th>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Name of FI Manager</td>
                                    <td colSpan="2">{questions[0] && questions[0].userAnswers && questions[0].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Employee code</td>
                                    <td colSpan="2">{questions[1] && questions[1].userAnswers && questions[1].userAnswers[0]}</td>

                                    <td colSpan="1" data-f-bold="true">Date of FI</td>
                                    <td colSpan="3">{questions[2] && questions[2].userAnswers && questions[2].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Time</td>
                                    <td colSpan="2">{questions[3] && questions[3].userAnswers && questions[3].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Applicant Name</td>
                                    <td colSpan="2">{questions[4] && questions[4].userAnswers && questions[4].userAnswers[0]}</td>
                                    <td colSpan="1">Phone</td>
                                    <td colSpan="2">{questions[6] && questions[6].userAnswers && questions[6].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Applicant Type</td>
                                    <td colSpan="1">{questions[7] && questions[7].userAnswers && questions[7].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Date of Birth</td>
                                    <td colSpan="1">{questions[5] && questions[5].userAnswers && questions[5].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Highest Education Level</td>
                                    <td colSpan="2">{questions[8] && questions[8].userAnswers && questions[8].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Marital Status</td>
                                    <td colSpan="1">{questions[9] && questions[9].userAnswers && questions[9].userAnswers[0]}</td>
                                    <td colSpan="2">&nbsp;</td>
                                    <td colSpan="2">&nbsp;</td>
                                </tr>
                              <tr>
                                    <td colSpan="1" data-f-bold="true">Person Met</td>
                                    <td colSpan="1">{questions[10] && questions[10].userAnswers && questions[10].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Relation with Applicant</td>
                                    <td colSpan="1">{questions[11] && questions[11].userAnswers && questions[11].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Living Since</td>
                                    <td colSpan="1">{questions[18] && questions[18].userAnswers && questions[18].userAnswers[0]}</td>
                                    <td colSpan="3" data-f-bold="true">Distance from Dealer Branch/Service centre</td>
                                    <td colSpan="1">{questions[21] && questions[21].userAnswers && questions[21].userAnswers[0]}</td>
                                </tr>
                                   <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Status</td>
                                    <td colSpan="3" >{questions[12] && questions[12].userAnswers && questions[12].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Locality & Traceability(Should not be in negative area and ease of access)</td>
                                    <td colSpan="2">{questions[19] && questions[19].userAnswers && questions[19].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Standard of Living</td>
                                    <td colSpan="2">{questions[20] && questions[20].userAnswers && questions[20].userAnswers[0]}</td>
                                </tr>
                              <tr>
                                    <td colSpan="1" data-f-bold="true">Current Address
                                    </td>
                                    <td colSpan="12">{questions[13] && questions[13].userAnswers && questions[13].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Landmark</td>
                                    <td colSpan="2">{questions[14] && questions[14].userAnswers && questions[14].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">City</td>
                                    <td colSpan="2">{questions[15] && questions[15].userAnswers && questions[15].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">State</td>
                                    <td colSpan="2">{questions[16] && questions[16].userAnswers && questions[16].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Postal Code</td>
                                    <td colSpan="3">{questions[17] && questions[17].userAnswers && questions[17].userAnswers[0]}</td>
                                </tr>
                                                           
                                <tr>
                                    <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Route MAP</th>
                                </tr>
                                <tr>
                                    <td colSpan="12">{questions[22] && questions[22].userAnswers && questions[22].userAnswers[0]}</td>
                                </tr>
                               
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Profile Feedback</th>
                                </tr>
                                <tr>
                                    <th colSpan="13">{questions[23] && questions[23].userAnswers && questions[23].userAnswers[0]}</th>
                                </tr>
                               
                            
                            </tbody>
                            )}

                            {checklistInfo.check_list_name === 'FI DCO Guarantor' && (
                            <tbody>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Field Investigation Details: {checklistInfo.check_list_name} </th>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Name of FI Manager</td>
                                    <td colSpan="2">{questions[0] && questions[0].userAnswers && questions[0].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Employee code</td>
                                    <td colSpan="2">{questions[1] && questions[1].userAnswers && questions[1].userAnswers[0]}</td>

                                    <td colSpan="1" data-f-bold="true">Date of FI</td>
                                    <td colSpan="3">{questions[2] && questions[2].userAnswers && questions[2].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Time</td>
                                    <td colSpan="2">{questions[3] && questions[3].userAnswers && questions[3].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true"> Applicant Name </td>
                                    <td colSpan="2">{questions[4] && questions[4].userAnswers && questions[4].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Phone</td>
                                    <td colSpan="2">{questions[6] && questions[6].userAnswers && questions[6].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Applicant Type</td>
                                    <td colSpan="1">{questions[7] && questions[7].userAnswers && questions[7].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Date of Birth</td>
                                    <td colSpan="1">{questions[5] && questions[5].userAnswers && questions[5].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Highest Education Level</td>
                                    <td colSpan="2">{questions[8] && questions[8].userAnswers && questions[8].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Marital Status</td>
                                    <td colSpan="1">{questions[9] && questions[9].userAnswers && questions[9].userAnswers[0]}</td>
                                    <td colSpan="2">&nbsp;</td>
                                    <td colSpan="2">&nbsp;</td>
                                </tr>
                              <tr>
                                    <td colSpan="1" data-f-bold="true">Person Met</td>
                                    <td colSpan="1">{questions[10] && questions[10].userAnswers && questions[10].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Relation with Guarantor</td>
                                    <td colSpan="1">{questions[11] && questions[11].userAnswers && questions[11].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Living Since</td>
                                    <td colSpan="1">{questions[18] && questions[18].userAnswers && questions[18].userAnswers[0]}</td>
                                    <td colSpan="3" data-f-bold="true">Distance from Dealer Branch/Service centre</td>
                                    <td colSpan="1">{questions[21] && questions[21].userAnswers && questions[21].userAnswers[0]}</td>
                                </tr>
                                   <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Status</td>
                                    <td colSpan="3" >{questions[12] && questions[12].userAnswers && questions[12].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Locality & Traceability(Should not be in negative area and ease of access)</td>
                                    <td colSpan="2">{questions[19] && questions[19].userAnswers && questions[19].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Standard of Living</td>
                                    <td colSpan="2" data-f-bold="true">{questions[20] && questions[20].userAnswers && questions[20].userAnswers[0]}</td>
                                </tr>
                              <tr>
                                    <td colSpan="1" data-f-bold="true">Current Address
                                    </td>
                                    <td colSpan="12">{questions[13] && questions[13].userAnswers && questions[13].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Landmark</td>
                                    <td colSpan="2">{questions[14] && questions[14].userAnswers && questions[14].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">City</td>
                                    <td colSpan="2">{questions[15] && questions[15].userAnswers && questions[15].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">State</td>
                                    <td colSpan="2">{questions[16] && questions[16].userAnswers && questions[16].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Postal Code</td>
                                    <td colSpan="3">{questions[17] && questions[17].userAnswers && questions[17].userAnswers[0]}</td>
                                </tr>
                                
                                                           
                                <tr>
                                    <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Route MAP</th>
                                </tr>
                                <tr>
                                    <td colSpan="12">{questions[22] && questions[22].userAnswers && questions[22].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Profile Feedback</th>
                                </tr>
                                <tr>
                                    <th colSpan="13">{questions[23] && questions[23].userAnswers && questions[23].userAnswers[0]}</th>
                                </tr>
                            </tbody>
                            )}

                            {checklistInfo.check_list_name === 'Fi Captive' && (
                            <tbody>                            
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Field Investigation Details: {checklistInfo.check_list_name} </th>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Name of FI Manager</td>
                                    <td colSpan="2">{questions[0] && questions[0].userAnswers && questions[0].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Employee code</td>
                                    <td colSpan="2">{questions[1] && questions[1].userAnswers && questions[1].userAnswers[0]}</td>

                                    <td colSpan="1" data-f-bold="true">Date of FI</td>
                                    <td colSpan="3">{questions[2] && questions[2].userAnswers && questions[2].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Time</td>
                                    <td colSpan="2">{questions[3] && questions[3].userAnswers && questions[3].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Applicant Name </td>
                                    <td colSpan="2">{questions[4] && questions[4].userAnswers && questions[4].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Date of Birth</td>
                                    <td colSpan="1">{questions[5] && questions[5].userAnswers && questions[5].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Phone</td>
                                    <td colSpan="2">{questions[6] && questions[6].userAnswers && questions[6].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Applicant Type</td>
                                    <td colSpan="1">{questions[7] && questions[7].userAnswers && questions[7].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Highest Education Level</td>
                                    <td colSpan="2">{questions[8] && questions[8].userAnswers && questions[8].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Marital Status</td>
                                    <td colSpan="1">{questions[9] && questions[9].userAnswers && questions[9].userAnswers[0]}</td>
                                    <td colSpan="2">&nbsp;</td>
                                    <td colSpan="2">&nbsp;</td>
                                </tr>
                              <tr>
                                    <td colSpan="1" data-f-bold="true">Person Met</td>
                                    <td colSpan="1">{questions[10] && questions[10].userAnswers && questions[10].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Relation with Applicant</td>
                                    <td colSpan="1">{questions[11] && questions[11].userAnswers && questions[11].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Living Since</td>
                                    <td colSpan="1">{questions[18] && questions[18].userAnswers && questions[18].userAnswers[0]}</td>
                                    <td colSpan="3" data-f-bold="true">Distance from Dealer Branch/Service centre</td>
                                    <td colSpan="1">{questions[21] && questions[21].userAnswers && questions[21].userAnswers[0]}</td>
                                </tr>
                                   <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Status</td>
                                    <td colSpan="3" >{questions[12] && questions[12].userAnswers && questions[12].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Locality & Traceability(Should not be in negative area and ease of access)</td>
                                    <td colSpan="2">{questions[19] && questions[19].userAnswers && questions[19].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Standard of Living</td>
                                    <td colSpan="2">{questions[20] && questions[20].userAnswers && questions[20].userAnswers[0]}</td>
                                    <td colSpan="2" data-f-bold="true">Commercial Driving Experience</td>
                                    <td colSpan="5">{questions[22] && questions[22].userAnswers && questions[22].userAnswers[0]}</td>
                                </tr>
                              <tr>
                                    <td colSpan="1" data-f-bold="true">Current Address
                                    </td>
                                    <td colSpan="12">{questions[13] && questions[13].userAnswers && questions[13].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Landmark</td>
                                    <td colSpan="2">{questions[14] && questions[14].userAnswers && questions[14].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">City</td>
                                    <td colSpan="2">{questions[15] && questions[15].userAnswers && questions[15].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">State</td>
                                    <td colSpan="2">{questions[16] && questions[16].userAnswers && questions[16].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Postal Code</td>
                                    <td colSpan="3">{questions[17] && questions[17].userAnswers && questions[17].userAnswers[0]}</td>
                                </tr>
                                
                                  <tr>
                                    <td colSpan="1" data-f-bold="true">First Neighbour Name</td>
                                    <td colSpan="5">{questions[23] && questions[23].userAnswers && questions[23].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Second Neighbour Name</td>
                                    <td colSpan="6">{questions[26] && questions[26].userAnswers && questions[26].userAnswers[0]}</td>
                                </tr>
                               <tr>
                                    <td colSpan="1" data-f-bold="true">First Neighbour Contact No.</td>
                                    <td colSpan="5">{questions[24] && questions[24].userAnswers && questions[24].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Second Neighbour Contact No.</td>
                                    <td colSpan="6">{questions[27] && questions[27].userAnswers && questions[27].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">First Neighbour Feedback</td>
                                    <td colSpan="5">{questions[25] && questions[25].userAnswers && questions[25].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Second Neighbour Feedback</td>
                                    <td colSpan="6">{questions[28] && questions[28].userAnswers && questions[28].userAnswers[0]}</td>
                                </tr>  

                                <tr>
                                    <td colSpan="1" data-f-bold="true">Firm/Co. Name</td>
                                    <td colSpan="5">{questions[29] && questions[29].userAnswers && questions[29].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Business Stability</td>
                                    <td colSpan="6">{questions[30] && questions[30].userAnswers && questions[30].userAnswers[0]}</td>
                                </tr>  

                                <tr>
                                    <td colSpan="1" data-f-bold="true">Business/Office Address</td>
                                    <td colSpan="5">{questions[31] && questions[31].userAnswers && questions[31].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Sign Board of Office Seen</td>
                                    <td colSpan="6">{questions[32] && questions[32].userAnswers && questions[32].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <td colSpan="1" data-f-bold="true">Value of stock</td>
                                    <td colSpan="5">{questions[33] && questions[33].userAnswers && questions[33].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Resi cum office</td>
                                    <td colSpan="6">{questions[34] && questions[34].userAnswers && questions[34].userAnswers[0]}</td>
                                </tr>

                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Business Activity seen which carried out the business</td>
                                    <td colSpan="5">{questions[35] && questions[35].userAnswers && questions[35].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">No. of employee seen</td>
                                    <td colSpan="6">{questions[36] && questions[36].userAnswers && questions[36].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Route MAP</th>
                                </tr>
                                <tr>
                                    <td colSpan="12">{questions[38] && questions[38].userAnswers && questions[38].userAnswers[0]}</td>
                                </tr>
                               <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Applicant - Vehicle Deployment</th>
                                </tr>
                                <tr>
                                    <td colSpan="13">{questions[37] && questions[37].userAnswers && questions[37].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Profile Feedback</th>
                                </tr>
                                <tr>
                                    <th colSpan="13">{questions[39] && questions[39].userAnswers && questions[39].userAnswers[0]}</th>
                                </tr>
                            </tbody>
                            )} 

                            {checklistInfo.check_list_name === 'Fi Captive Co-Applicant' && (
                            <tbody>                            
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Field Investigation Details: {checklistInfo.check_list_name} </th>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Name of FI Manager</td>
                                    <td colSpan="2">{questions[0] && questions[0].userAnswers && questions[0].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Employee code</td>
                                    <td colSpan="2">{questions[1] && questions[1].userAnswers && questions[1].userAnswers[0]}</td>

                                    <td colSpan="1" data-f-bold="true">Date of FI</td>
                                    <td colSpan="3">{questions[2] && questions[2].userAnswers && questions[2].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Time</td>
                                    <td colSpan="2">{questions[3] && questions[3].userAnswers && questions[3].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Applicant Name </td>
                                    <td colSpan="2">{questions[4] && questions[4].userAnswers && questions[4].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Date of Birth</td>
                                    <td colSpan="1">{questions[5] && questions[5].userAnswers && questions[5].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Phone</td>
                                    <td colSpan="2">{questions[6] && questions[6].userAnswers && questions[6].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Applicant Type</td>
                                    <td colSpan="1">{questions[7] && questions[7].userAnswers && questions[7].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Highest Education Level</td>
                                    <td colSpan="2">{questions[8] && questions[8].userAnswers && questions[8].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Marital Status</td>
                                    <td colSpan="1">{questions[9] && questions[9].userAnswers && questions[9].userAnswers[0]}</td>
                                    <td colSpan="2">&nbsp;</td>
                                    <td colSpan="2">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Person Met</td>
                                    <td colSpan="1">{questions[10] && questions[10].userAnswers && questions[10].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Relation with Co-Applican</td>
                                    <td colSpan="1">{questions[11] && questions[11].userAnswers && questions[11].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Living Since</td>
                                    <td colSpan="1">{questions[18] && questions[18].userAnswers && questions[18].userAnswers[0]}</td>
                                </tr>
                                   <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Status</td>
                                    <td colSpan="3" >{questions[12] && questions[12].userAnswers && questions[12].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Locality & Traceability(Should not be in negative area and ease of access)</td>
                                    <td colSpan="2">{questions[19] && questions[19].userAnswers && questions[19].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Standard of Living</td>
                                    <td colSpan="2">{questions[20] && questions[20].userAnswers && questions[20].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Current Address
                                    </td>
                                    <td colSpan="12">{questions[13] && questions[13].userAnswers && questions[13].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Landmark</td>
                                    <td colSpan="2">{questions[14] && questions[14].userAnswers && questions[14].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">City</td>
                                    <td colSpan="2">{questions[15] && questions[15].userAnswers && questions[15].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">State</td>
                                    <td colSpan="2">{questions[16] && questions[16].userAnswers && questions[16].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Postal Code</td>
                                    <td colSpan="3">{questions[17] && questions[17].userAnswers && questions[17].userAnswers[0]}</td>
                                </tr>
                                
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Distance from Dealer Branch/Service centre</td>
                                    <td colSpan="5">{questions[21] && questions[21].userAnswers && questions[21].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Route MAP</th>
                                </tr>
                                <tr>
                                    <td colSpan="12">{questions[22] && questions[22].userAnswers && questions[22].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Profile Feedback</th>
                                </tr>
                                <tr>
                                    <th colSpan="13">{questions[23] && questions[23].userAnswers && questions[23].userAnswers[0]}</th>
                                </tr>
                            </tbody>
                            )} 

                            {checklistInfo.check_list_name === 'FI Captive Guarantor' && (
                            <tbody>                            
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Field Investigation Details: {checklistInfo.check_list_name} </th>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Name of FI Manager</td>
                                    <td colSpan="2">{questions[0] && questions[0].userAnswers && questions[0].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Employee code</td>
                                    <td colSpan="2">{questions[1] && questions[1].userAnswers && questions[1].userAnswers[0]}</td>

                                    <td colSpan="1" data-f-bold="true">Date of FI</td>
                                    <td colSpan="3">{questions[2] && questions[2].userAnswers && questions[2].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Time</td>
                                    <td colSpan="2">{questions[3] && questions[3].userAnswers && questions[3].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Applicant Name </td>
                                    <td colSpan="2">{questions[4] && questions[4].userAnswers && questions[4].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Date of Birth</td>
                                    <td colSpan="1">{questions[5] && questions[5].userAnswers && questions[5].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Phone</td>
                                    <td colSpan="2">{questions[6] && questions[6].userAnswers && questions[6].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Applicant Type</td>
                                    <td colSpan="1">{questions[7] && questions[7].userAnswers && questions[7].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Highest Education Level</td>
                                    <td colSpan="2">{questions[8] && questions[8].userAnswers && questions[8].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Marital Status</td>
                                    <td colSpan="1">{questions[9] && questions[9].userAnswers && questions[9].userAnswers[0]}</td>
                                    <td colSpan="2">&nbsp;</td>
                                    <td colSpan="2">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Person Met</td>
                                    <td colSpan="1">{questions[10] && questions[10].userAnswers && questions[10].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Relation with Guarantor</td>
                                    <td colSpan="1">{questions[11] && questions[11].userAnswers && questions[11].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Living Since</td>
                                    <td colSpan="1">{questions[18] && questions[18].userAnswers && questions[18].userAnswers[0]}</td>
                                </tr>
                                   <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Status</td>
                                    <td colSpan="3" >{questions[12] && questions[12].userAnswers && questions[12].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Locality & Traceability(Should not be in negative area and ease of access)</td>
                                    <td colSpan="2">{questions[19] && questions[19].userAnswers && questions[19].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Standard of Living</td>
                                    <td colSpan="2">{questions[20] && questions[20].userAnswers && questions[20].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Current Address
                                    </td>
                                    <td colSpan="12">{questions[13] && questions[13].userAnswers && questions[13].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Landmark</td>
                                    <td colSpan="2">{questions[14] && questions[14].userAnswers && questions[14].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">City</td>
                                    <td colSpan="2">{questions[15] && questions[15].userAnswers && questions[15].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">State</td>
                                    <td colSpan="2">{questions[16] && questions[16].userAnswers && questions[16].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Postal Code</td>
                                    <td colSpan="3">{questions[17] && questions[17].userAnswers && questions[17].userAnswers[0]}</td>
                                </tr>
                                
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Distance from Dealer Branch/Service centre</td>
                                    <td colSpan="5">{questions[21] && questions[21].userAnswers && questions[21].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Route MAP</th>
                                </tr>
                                <tr>
                                    <td colSpan="12">{questions[22] && questions[22].userAnswers && questions[22].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Profile Feedback</th>
                                </tr>
                                <tr>
                                    <th colSpan="13">{questions[23] && questions[23].userAnswers && questions[23].userAnswers[0]}</th>
                                </tr>
                            </tbody>
                            )}

                            {checklistInfo.check_list_name === 'Fi Bulk' && (
                            <tbody>                            
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Field Investigation Details: {checklistInfo.check_list_name} </th>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Name of FI Manager</td>
                                    <td colSpan="2">{questions[0] && questions[0].userAnswers && questions[0].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Employee code</td>
                                    <td colSpan="2">{questions[1] && questions[1].userAnswers && questions[1].userAnswers[0]}</td>

                                    <td colSpan="1" data-f-bold="true">Date of FI</td>
                                    <td colSpan="3">{questions[2] && questions[2].userAnswers && questions[2].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Time</td>
                                    <td colSpan="2">{questions[3] && questions[3].userAnswers && questions[3].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Applicant Name </td>
                                    <td colSpan="2">{questions[4] && questions[4].userAnswers && questions[4].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Date of Birth</td>
                                    <td colSpan="1">{questions[5] && questions[5].userAnswers && questions[5].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Phone</td>
                                    <td colSpan="2">{questions[6] && questions[6].userAnswers && questions[6].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Applicant Type</td>
                                    <td colSpan="1">{questions[7] && questions[7].userAnswers && questions[7].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Highest Education Level</td>
                                    <td colSpan="2">{questions[8] && questions[8].userAnswers && questions[8].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Marital Status</td>
                                    <td colSpan="1">{questions[9] && questions[9].userAnswers && questions[9].userAnswers[0]}</td>
                                    <td colSpan="2">&nbsp;</td>
                                    <td colSpan="2">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Person Met</td>
                                    <td colSpan="1">{questions[10] && questions[10].userAnswers && questions[10].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Relation with Applicant</td>
                                    <td colSpan="1">{questions[11] && questions[11].userAnswers && questions[11].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Living Since</td>
                                    <td colSpan="1">{questions[18] && questions[18].userAnswers && questions[18].userAnswers[0]}</td>
                                    <td colSpan="3" data-f-bold="true">Distance from Dealer Branch/Service centre</td>
                                    <td colSpan="1">{questions[21] && questions[21].userAnswers && questions[21].userAnswers[0]}</td>
                                </tr>
                                   <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Status</td>
                                    <td colSpan="3" >{questions[12] && questions[12].userAnswers && questions[12].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Locality & Traceability(Should not be in negative area and ease of access)</td>
                                    <td colSpan="2">{questions[19] && questions[19].userAnswers && questions[19].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Standard of Living</td>
                                    <td colSpan="2">{questions[20] && questions[20].userAnswers && questions[20].userAnswers[0]}</td>
                                    <td colSpan="2" data-f-bold="true">Commercial Driving Experience</td>
                                    <td colSpan="5">{questions[22] && questions[22].userAnswers && questions[22].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Current Address
                                    </td>
                                    <td colSpan="12">{questions[13] && questions[13].userAnswers && questions[13].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Landmark</td>
                                    <td colSpan="2">{questions[14] && questions[14].userAnswers && questions[14].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">City</td>
                                    <td colSpan="2">{questions[15] && questions[15].userAnswers && questions[15].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">State</td>
                                    <td colSpan="2">{questions[16] && questions[16].userAnswers && questions[16].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Postal Code</td>
                                    <td colSpan="3">{questions[17] && questions[17].userAnswers && questions[17].userAnswers[0]}</td>
                                </tr>
                                
                                  <tr>
                                    <td colSpan="1" data-f-bold="true">First Neighbour Name</td>
                                    <td colSpan="5">{questions[23] && questions[23].userAnswers && questions[23].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Second Neighbour Name</td>
                                    <td colSpan="6">{questions[26] && questions[26].userAnswers && questions[26].userAnswers[0]}</td>
                                </tr>
                               <tr>
                                    <td colSpan="1" data-f-bold="true">First Neighbour Contact No.</td>
                                    <td colSpan="5">{questions[24] && questions[24].userAnswers && questions[24].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Second Neighbour Contact No.</td>
                                    <td colSpan="6">{questions[27] && questions[27].userAnswers && questions[27].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">First Neighbour Feedback</td>
                                    <td colSpan="5">{questions[25] && questions[25].userAnswers && questions[25].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Second Neighbour Feedback</td>
                                    <td colSpan="6">{questions[28] && questions[28].userAnswers && questions[28].userAnswers[0]}</td>
                                </tr>  

                                <tr>
                                    <td colSpan="1" data-f-bold="true">Firm/Co. Name</td>
                                    <td colSpan="5">{questions[29] && questions[29].userAnswers && questions[29].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Business Stability</td>
                                    <td colSpan="6">{questions[30] && questions[30].userAnswers && questions[30].userAnswers[0]}</td>
                                </tr>  

                                <tr>
                                    <td colSpan="1" data-f-bold="true">Business/Office Address</td>
                                    <td colSpan="5">{questions[31] && questions[31].userAnswers && questions[31].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Sign Board of Office Seen</td>
                                    <td colSpan="6">{questions[32] && questions[32].userAnswers && questions[32].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <td colSpan="1" data-f-bold="true">Value of stock</td>
                                    <td colSpan="5">{questions[33] && questions[33].userAnswers && questions[33].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Resi cum office</td>
                                    <td colSpan="6">{questions[34] && questions[34].userAnswers && questions[34].userAnswers[0]}</td>
                                </tr>

                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Business Activity seen which carried out the business</td>
                                    <td colSpan="5">{questions[35] && questions[35].userAnswers && questions[35].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">No. of employee seen</td>
                                    <td colSpan="6">{questions[36] && questions[36].userAnswers && questions[36].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Route MAP</th>
                                </tr>
                                <tr>
                                    <td colSpan="12">{questions[38] && questions[38].userAnswers && questions[38].userAnswers[0]}</td>
                                </tr>
                               <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Applicant - Vehicle Deployment</th>
                                </tr>
                                <tr>
                                    <td colSpan="13">{questions[37] && questions[37].userAnswers && questions[37].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Profile Feedback</th>
                                </tr>
                                <tr>
                                    <th colSpan="13">{questions[39] && questions[39].userAnswers && questions[39].userAnswers[0]}</th>
                                </tr>

                                <tr>
                                    <td colSpan="1" data-f-bold="true">Exisiting Vehicle</td>
                                    <td colSpan="5">{questions[40] && questions[40].userAnswers && questions[40].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Total Vehicle</td>
                                    <td colSpan="6">{questions[41] && questions[41].userAnswers && questions[41].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <td colSpan="1" data-f-bold="true">Vehicle no</td>
                                    <td colSpan="5">{questions[42] && questions[42].userAnswers && questions[42].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Asset Description</td>
                                    <td colSpan="6">{questions[43] && questions[43].userAnswers && questions[43].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <td colSpan="1" data-f-bold="true">Finance/Free</td>
                                    <td colSpan="5">{questions[44] && questions[44].userAnswers && questions[44].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">EMI-Paid/Total Tenure</td>
                                    <td colSpan="6">{questions[45] && questions[45].userAnswers && questions[45].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Any other Income</td>
                                    <td colSpan="6">{questions[46] && questions[46].userAnswers && questions[46].userAnswers[0]}</td>
                                </tr> 

                            </tbody>
                            )} 

                            {checklistInfo.check_list_name === 'Fi Bulk Co-Applicant' && (
                            <tbody>                            
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Field Investigation Details: {checklistInfo.check_list_name} </th>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Name of FI Manager</td>
                                    <td colSpan="2">{questions[0] && questions[0].userAnswers && questions[0].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Employee code</td>
                                    <td colSpan="2">{questions[1] && questions[1].userAnswers && questions[1].userAnswers[0]}</td>

                                    <td colSpan="1" data-f-bold="true">Date of FI</td>
                                    <td colSpan="3">{questions[2] && questions[2].userAnswers && questions[2].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Time</td>
                                    <td colSpan="2">{questions[3] && questions[3].userAnswers && questions[3].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Applicant Name </td>
                                    <td colSpan="2">{questions[4] && questions[4].userAnswers && questions[4].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Date of Birth</td>
                                    <td colSpan="1">{questions[5] && questions[5].userAnswers && questions[5].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Phone</td>
                                    <td colSpan="2">{questions[6] && questions[6].userAnswers && questions[6].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Applicant Type</td>
                                    <td colSpan="1">{questions[7] && questions[7].userAnswers && questions[7].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Highest Education Level</td>
                                    <td colSpan="2">{questions[8] && questions[8].userAnswers && questions[8].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Marital Status</td>
                                    <td colSpan="1">{questions[9] && questions[9].userAnswers && questions[9].userAnswers[0]}</td>
                                    <td colSpan="2">&nbsp;</td>
                                    <td colSpan="2">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Person Met</td>
                                    <td colSpan="1">{questions[10] && questions[10].userAnswers && questions[10].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Relation with Co-Applican</td>
                                    <td colSpan="1">{questions[11] && questions[11].userAnswers && questions[11].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Living Since</td>
                                    <td colSpan="1">{questions[18] && questions[18].userAnswers && questions[18].userAnswers[0]}</td>
                                </tr>
                                   <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Status</td>
                                    <td colSpan="3" >{questions[12] && questions[12].userAnswers && questions[12].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Locality & Traceability(Should not be in negative area and ease of access)</td>
                                    <td colSpan="2">{questions[19] && questions[19].userAnswers && questions[19].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Standard of Living</td>
                                    <td colSpan="2">{questions[20] && questions[20].userAnswers && questions[20].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Current Address
                                    </td>
                                    <td colSpan="12">{questions[13] && questions[13].userAnswers && questions[13].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Landmark</td>
                                    <td colSpan="2">{questions[14] && questions[14].userAnswers && questions[14].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">City</td>
                                    <td colSpan="2">{questions[15] && questions[15].userAnswers && questions[15].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">State</td>
                                    <td colSpan="2">{questions[16] && questions[16].userAnswers && questions[16].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Postal Code</td>
                                    <td colSpan="3">{questions[17] && questions[17].userAnswers && questions[17].userAnswers[0]}</td>
                                </tr>
                                
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Distance from Dealer Branch/Service centre</td>
                                    <td colSpan="5">{questions[21] && questions[21].userAnswers && questions[21].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Route MAP</th>
                                </tr>
                                <tr>
                                    <td colSpan="12">{questions[22] && questions[22].userAnswers && questions[22].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Profile Feedback</th>
                                </tr>
                                <tr>
                                    <th colSpan="13">{questions[23] && questions[23].userAnswers && questions[23].userAnswers[0]}</th>
                                </tr>
                            </tbody>
                            )} 

                            {checklistInfo.check_list_name === 'FI Bulk Guarantor' && (
                            <tbody>                            
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Field Investigation Details: {checklistInfo.check_list_name} </th>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Name of FI Manager</td>
                                    <td colSpan="2">{questions[0] && questions[0].userAnswers && questions[0].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Employee code</td>
                                    <td colSpan="2">{questions[1] && questions[1].userAnswers && questions[1].userAnswers[0]}</td>

                                    <td colSpan="1" data-f-bold="true">Date of FI</td>
                                    <td colSpan="2">{questions[2] && questions[2].userAnswers && questions[2].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Time</td>
                                    <td colSpan="2">{questions[3] && questions[3].userAnswers && questions[3].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Applicant Name </td>
                                    <td colSpan="2">{questions[4] && questions[4].userAnswers && questions[4].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Date of Birth</td>
                                    <td colSpan="1">{questions[5] && questions[5].userAnswers && questions[5].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Phone</td>
                                    <td colSpan="2">{questions[6] && questions[6].userAnswers && questions[6].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Applicant Type</td>
                                    <td colSpan="1">{questions[7] && questions[7].userAnswers && questions[7].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Highest Education Level</td>
                                    <td colSpan="2">{questions[8] && questions[8].userAnswers && questions[8].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Marital Status</td>
                                    <td colSpan="1">{questions[9] && questions[9].userAnswers && questions[9].userAnswers[0]}</td>
                                    <td colSpan="2">&nbsp;</td>
                                    <td colSpan="2">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Person Met</td>
                                    <td colSpan="1">{questions[10] && questions[10].userAnswers && questions[10].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Relation with Guarantor</td>
                                    <td colSpan="1">{questions[11] && questions[11].userAnswers && questions[11].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Living Since</td>

                                    
                                    <td colSpan="1">{questions[18] && questions[18].userAnswers && questions[18].userAnswers[0]}</td>
                                </tr>
                                   <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Status</td>
                                    <td colSpan="3" >{questions[12] && questions[12].userAnswers && questions[12].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Residence Locality & Traceability(Should not be in negative area and ease of access)</td>
                                    <td colSpan="2">{questions[19] && questions[19].userAnswers && questions[19].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Standard of Living</td>
                                    <td colSpan="2">{questions[20] && questions[20].userAnswers && questions[20].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <td colSpan="1" data-f-bold="true">Current Address
                                    </td>
                                    <td colSpan="12">{questions[13] && questions[13].userAnswers && questions[13].userAnswers[0]}</td>
                                </tr>
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Landmark</td>
                                    <td colSpan="2">{questions[14] && questions[14].userAnswers && questions[14].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">City</td>
                                    <td colSpan="2">{questions[15] && questions[15].userAnswers && questions[15].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">State</td>
                                    <td colSpan="2">{questions[16] && questions[16].userAnswers && questions[16].userAnswers[0]}</td>
                                    <td colSpan="1" data-f-bold="true">Postal Code</td>
                                    <td colSpan="3">{questions[17] && questions[17].userAnswers && questions[17].userAnswers[0]}</td>
                                </tr>
                                
                                 <tr>
                                    <td colSpan="1" data-f-bold="true">Distance from Dealer Branch/Service centre</td>
                                    <td colSpan="5">{questions[21] && questions[21].userAnswers && questions[21].userAnswers[0]}</td>
                                </tr> 

                                <tr>
                                    <th colSpan="12" style={{ textAlign: 'center' }} data-f-bold="true">Route MAP</th>
                                </tr>
                                <tr>
                                    <td colSpan="12">{questions[22] && questions[22].userAnswers && questions[22].userAnswers[0]}</td>
                                </tr>
                                <tr>
                                    <th colSpan="13" style={{ textAlign: 'center' }} data-f-bold="true">Profile Feedback</th>
                                </tr>
                                <tr>
                                    <th colSpan="13">{questions[23] && questions[23].userAnswers && questions[23].userAnswers[0]}</th>
                                </tr>
                            </tbody>
                            )}


                        </table>


                    </div>



        </div>
        
    );
}

function mapStateToProps(state) {
    return {
        leadsData: state.leadsData,
        leadInfo: state.leadInfo,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(leadActions.default), dispatch),
    }
}

const overlayStyles = {
  container: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    fontSize: "12px",
  },
  box: {
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "350px",
    textAlign: "center",
    position: "relative"
  },
  closeBtn: {
    position: "absolute",
    top: "5px",
    right: "10px",
    border: "none",
    background: "transparent",
    fontSize: "20px",
    cursor: "pointer"
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadQuestionnaire);